var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnschlussanfrage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 312,
    viewBox: "0 0 457 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Anschlussanfrage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.728 311.133L0.144775 174.566L0.179688 155.38L38.8348 137.823L252.182 273.877V299.441L236.728 311.133Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.733 311.509L0.14502 174.913V172.374L236.733 309.116V311.509Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.69 184.763L236.732 311.51L236.732 252.55L417.784 153.033L456.674 165.172L456.69 184.763Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.14502 155.43L236.727 292.719L456.675 165.172L219.948 40.3381L0.14502 155.43Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 332",
    d: "M211.327 118.69L314.648 176.807L308.521 180.273L206.51 121.473L211.327 118.69Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 333",
    d: "M210.574 118.69L134.455 162.414L140.291 165.807L215.907 121.93L210.574 118.69Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M359.184 187.07L326.438 205.976L293.692 187.07L326.438 168.165L359.184 187.07Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hide2",
    d: "M285.448 138.707L211.514 95.6209L130.759 138.707L211.514 181.773L285.448 138.707Z",
    fill: "#65813F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 415",
    d: "M124.683 170.157L176.095 133.219L224.298 153.303L134.169 193.813L124.683 170.157Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 331",
    d: "M317.55 187.069L241.432 230.793L247.267 234.186L322.883 190.309L317.55 187.069Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 330",
    d: "M149.985 172.537L253.306 230.654L247.179 234.12L145.168 175.32L149.985 172.537Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot-anschlussanfrage-hinten",
    cx: 306.7,
    cy: 173.149,
    r: 6.31184,
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M424.803 163.986C431.262 166.651 431.262 171.048 424.803 173.827C417.528 176.549 408.92 176.549 401.646 173.827C395.188 171.163 395.188 166.765 401.646 163.986C408.92 161.264 417.528 161.264 424.803 163.986Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M412.866 168.711L409.422 148.016C409.505 148.861 409.084 149.504 408.158 150.085C406.406 151.187 403.502 151.339 401.672 150.372C400.721 149.871 400.249 149.209 400.258 148.515L400.256 148.516L398.181 170.109C398.072 171.327 398.843 172.528 400.481 173.394C403.47 174.973 408.215 174.773 411.077 172.973C412.989 171.771 413.575 170.126 412.866 168.711Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M396.97 108.845C406.546 108.845 414.309 116.851 414.309 126.726C414.309 136.6 406.546 144.606 396.97 144.606C387.394 144.606 379.632 136.6 379.632 126.726C379.632 116.851 387.394 108.845 396.97 108.845Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M406.759 122.588C401.052 125.715 391.806 125.715 386.099 122.588C383.498 121.198 382.126 119.322 381.837 117.515C381.547 119.809 382.92 122.101 386.099 123.838C391.806 126.966 401.052 126.966 406.759 123.838C409.866 122.101 411.311 119.807 411.022 117.515C410.732 119.391 409.361 121.195 406.759 122.588Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M408.289 135.142C401.737 138.661 391.121 138.661 384.569 135.142C381.583 133.579 380.007 131.468 379.675 129.435C379.343 132.016 380.919 134.594 384.569 136.549C391.121 140.067 401.737 140.067 408.289 136.549C411.857 134.594 413.515 132.014 413.184 129.435C412.851 131.546 411.277 133.576 408.289 135.142Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M412.142 117.515C421.717 117.515 429.48 125.52 429.48 135.395C429.48 145.27 421.717 153.275 412.142 153.275C402.566 153.275 394.803 145.27 394.803 135.395C394.803 125.52 402.566 117.515 412.142 117.515Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M422.855 131.257C416.936 134.385 407.348 134.385 401.43 131.257C398.733 129.868 397.309 127.991 397.01 126.184C396.709 128.478 398.133 130.77 401.43 132.508C407.348 135.635 416.936 135.635 422.855 132.508C426.077 130.77 427.575 128.477 427.275 126.184C426.975 128.06 425.553 129.865 422.855 131.257Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M424.544 143.812C417.992 147.33 407.376 147.33 400.824 143.812C397.838 142.248 396.262 140.138 395.93 138.104C395.598 140.685 397.174 143.264 400.824 145.218C407.376 148.737 417.992 148.737 424.544 145.218C428.112 143.264 429.77 140.684 429.439 138.104C429.106 140.215 427.532 142.245 424.544 143.812Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M396.971 132.686C403.554 132.686 408.891 138.266 408.891 145.148C408.891 152.03 403.554 157.61 396.971 157.61C390.387 157.61 385.051 152.03 385.051 145.148C385.051 138.266 390.387 132.686 396.971 132.686Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M403.698 142.993C399.682 145.338 393.176 145.338 389.16 142.993C387.33 141.951 386.364 140.543 386.161 139.188C385.957 140.908 386.923 142.628 389.16 143.931C393.176 146.276 399.682 146.276 403.698 143.931C405.885 142.628 406.901 140.907 406.698 139.188C406.494 140.595 405.529 141.948 403.698 142.993Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M405.388 151.662C400.738 154.008 393.204 154.008 388.554 151.662C386.435 150.62 385.317 149.213 385.081 147.857C384.845 149.578 385.964 151.297 388.554 152.6C393.204 154.945 400.738 154.945 405.388 152.6C407.92 151.297 409.097 149.577 408.861 147.857C408.626 149.264 407.508 150.618 405.388 151.662Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M244.648 84.9907C251.107 87.6558 251.107 92.0528 244.648 94.8324C237.372 97.5542 228.765 97.5542 221.49 94.8324C215.033 92.1683 215.033 87.7703 221.49 84.9907C228.765 82.2689 237.372 82.2689 244.648 84.9907Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M232.71 89.7158L229.266 69.0211C229.349 69.8657 228.928 70.5091 228.003 71.0906C226.251 72.1924 223.346 72.3444 221.516 71.3775C220.565 70.8758 220.093 70.2142 220.103 69.5206L220.1 69.5207L218.025 91.1141C217.916 92.3316 218.687 93.5334 220.325 94.399C223.315 95.9786 228.059 95.7781 230.921 93.9782C232.833 92.7758 233.42 91.1309 232.71 89.7158Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M216.815 29.8505C226.39 29.8505 234.153 37.8562 234.153 47.7308C234.153 57.6054 226.39 65.6111 216.815 65.6111C207.239 65.6111 199.476 57.6054 199.476 47.7308C199.476 37.8562 207.239 29.8505 216.815 29.8505Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M226.603 43.5932C220.896 46.7204 211.65 46.7204 205.944 43.5932C203.343 42.2035 201.97 40.3273 201.681 38.5198C201.392 40.8138 202.765 43.106 205.944 44.8436C211.65 47.9708 220.896 47.9708 226.603 44.8436C229.71 43.106 231.155 40.8126 230.866 38.5198C230.577 40.396 229.205 42.2005 226.603 43.5932Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M228.134 56.1476C221.581 59.6657 210.966 59.6657 204.413 56.1476C201.427 54.5842 199.851 52.4734 199.52 50.44C199.187 53.0208 200.764 55.5996 204.413 57.5543C210.966 61.0724 221.581 61.0724 228.134 57.5543C231.701 55.5996 233.36 53.0194 233.028 50.44C232.696 52.5508 231.121 54.5809 228.134 56.1476Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M231.986 38.5198C241.562 38.5198 249.325 46.5255 249.325 56.4001C249.325 66.2747 241.562 74.2804 231.986 74.2804C222.41 74.2804 214.648 66.2747 214.648 56.4001C214.648 46.5255 222.41 38.5198 231.986 38.5198Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M242.699 52.2624C236.781 55.3897 227.192 55.3897 221.274 52.2624C218.577 50.8727 217.154 48.9965 216.854 47.189C216.554 49.483 217.978 51.7753 221.274 53.5128C227.192 56.6401 236.781 56.6401 242.699 53.5128C245.921 51.7753 247.419 49.4819 247.12 47.189C246.82 49.0653 245.397 50.8698 242.699 52.2624Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M244.389 64.8168C237.837 68.335 227.221 68.335 220.668 64.8168C217.682 63.2534 216.106 61.1427 215.775 59.1093C215.442 61.69 217.019 64.2688 220.668 66.2235C227.221 69.7417 237.837 69.7417 244.389 66.2235C247.956 64.2688 249.615 61.6887 249.283 59.1093C248.951 61.22 247.376 63.2501 244.389 64.8168Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M216.815 53.691C223.398 53.691 228.735 59.2707 228.735 66.153C228.735 73.0353 223.398 78.6151 216.815 78.6151C210.232 78.6151 204.895 73.0353 204.895 66.153C204.895 59.2707 210.232 53.691 216.815 53.691Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M223.543 63.998C219.527 66.3434 213.021 66.3434 209.005 63.998C207.174 62.9557 206.208 61.5485 206.005 60.1929C205.801 61.9134 206.768 63.6326 209.005 64.9358C213.021 67.2812 219.527 67.2812 223.543 64.9358C225.729 63.6326 226.746 61.9126 226.543 60.1929C226.339 61.6001 225.374 62.9535 223.543 63.998Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M225.233 72.6672C220.582 75.0127 213.049 75.0127 208.399 72.6672C206.28 71.625 205.161 70.2178 204.926 68.8622C204.69 70.5827 205.809 72.3019 208.399 73.605C213.049 75.9505 220.582 75.9505 225.233 73.605C227.764 72.3019 228.941 70.5818 228.706 68.8622C228.47 70.2694 227.353 71.6228 225.233 72.6672Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mast"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.185 139.317L409.47 138.571L409.469 138.572L409.445 138.583L390.868 133.49L391.375 134.22L390.794 133.451L388.079 132.706L386.491 133.433L386.507 133.455L383.701 134.791L369.719 126.225L355.452 133.52L355.454 133.524L355.449 133.52L353.861 134.247L361.74 145.167L350.8 150.375L349.21 151.102L349.227 151.124L338.396 156.28L338.357 156.27L338.373 156.291L338.34 156.307L339.462 157.779L337.906 158.491L339.031 159.962L326.845 165.763L328.183 165.126L340.825 168.47L345.022 167.797L345.771 168.776L344.418 169.421L340.825 168.47L335.553 169.316L341.315 170.898L333.287 174.719L329.998 170.207L335.553 169.316L327.795 167.186L326.78 165.794L324.107 165.06L322.555 165.799L323.677 167.271L314.781 171.506L312.108 170.772L310.557 171.511L311.679 172.983L311.161 173.229L311.79 173.129L317.383 180.467L320.945 176.874L311.161 173.229L315.598 175.406L308.624 178.727L318.713 191.966L327.795 200.695L370.934 176.847L370.921 176.843L372.469 176.106L372.481 176.11L372.476 176.103L381.824 171.653L393.296 186.78L393.316 186.852L393.341 186.84L393.346 186.846L394.626 186.237L393.337 186.856L396.01 187.59L414.725 192.696L414.735 192.708L414.728 192.711L417.402 193.445L418.924 192.714L416.283 191.989L416.287 191.987L418.928 192.712L409.739 158.442L422.165 152.527L412.185 139.317ZM393.308 180.456L393.648 181.723L393.652 181.727L393.309 180.456L393.308 180.456ZM386.118 160.09L384.583 154.378L377.532 157.738L386.118 160.09ZM387.431 164.97L386.77 162.514L377.052 159.793L382.27 166.688L382.252 166.664L383.281 166.945L387.431 164.97ZM390.826 177.594L388.956 170.639L385.832 169.745L384.914 170.182L390.993 178.214L390.989 178.201L390.495 177.503L390.826 177.594ZM397.513 186.83L397.529 186.821L397.481 186.754L397.495 186.806L397.513 186.83ZM395.994 181.21L397.173 185.604L412.543 189.815L408.727 184.778L408.723 184.78L395.994 181.21ZM400.481 173.94L393.51 171.944L395.358 178.835L406.546 181.9L400.507 173.928L400.481 173.94ZM392.874 169.573L392.118 166.752L394.288 165.719L398.342 171.071L392.874 169.573ZM391.045 161.439L390.5 160.72L390.665 161.335L391.045 161.439ZM409.153 182.614L402.027 173.204L402.032 173.202L401.584 172.602L409.167 182.618L409.153 182.614ZM413.595 188.465L410.253 184.052L410.244 184.056L413.601 188.489L413.595 188.465ZM400.954 171.787L400.969 171.791L395.82 164.99L395.81 164.995L400.954 171.787ZM412.426 184.119L405.999 160.222L397.43 164.302L412.426 184.119ZM414.42 185.161L415.082 187.629L415.085 187.634L414.42 185.161ZM393.026 136.405L406.342 140.06L398.579 143.756L393.026 136.405ZM387.293 137.118L391.276 139.699L388.768 136.415L387.293 137.118ZM377.377 137.801L381.311 135.929L370.799 129.109L377.377 137.801ZM392.76 143.357L384.901 138.258L380.979 140.126L392.76 143.357ZM415.817 149.674L410.189 142.266L402.372 145.99L415.817 149.674ZM407.526 155.481L402.019 148.193L415.251 151.804L407.526 155.481ZM369.719 133.773L370.445 134.247L370.184 133.903L369.719 133.773ZM374.576 136.952L374.603 136.97L371.757 133.211L371.746 133.216L374.576 136.952ZM364.902 143.74L369.763 141.426L361.321 139.008L364.902 143.74ZM372.682 140.036L374.092 139.365L362.238 131.674L356.593 134.791L372.682 140.036ZM375.059 142.942L377.331 143.593L381.902 149.578L368.719 145.963L375.059 142.942ZM386.269 149.553L393.797 145.969L380.872 142.42L386.269 149.553ZM368.246 148.157L381.517 151.8L373.788 155.48L368.246 148.157ZM372.222 156.225L365.553 147.418L365.552 147.418L372.222 156.225ZM355.967 151.955L369.628 155.569L363.989 148.133L355.967 151.955ZM361.263 161.379L355.733 154.059L368.993 157.699L361.263 161.379ZM395.197 161.351L402.87 157.699L389.717 154.109L395.197 161.351ZM403.39 155.556L397.78 148.174L389.991 151.886L403.39 155.556ZM351.488 154.085L357.147 161.494L343.508 157.887L351.488 154.085ZM348.853 167.286L348.782 167.194L349.183 167.129L348.853 167.286ZM372.908 159.936L364.947 163.728L378.517 167.318L372.908 159.936ZM370.235 173.156L377.973 169.472L364.65 165.814L370.235 173.156ZM325.15 182.606L333.112 178.816L338.741 186.201L325.15 182.606ZM341.385 186.901L342.722 186.264L337.552 179.172L350.28 182.666L341.385 186.901ZM337.148 176.895L345.11 173.104L350.74 180.49L337.148 176.895ZM353.383 181.189L365.529 175.407L349.511 171.009L348.213 171.627L354.72 180.552L353.383 181.189ZM350.994 170.303L360.394 165.828L366.074 173.253L352.398 169.635L350.994 170.303ZM328.973 174.22L326.359 170.791L319.916 171.825L328.973 174.22ZM317.425 172.224L319.916 171.825L316.185 170.838L314.781 171.506L317.425 172.224ZM317.425 172.224L314.781 171.506L315.527 172.529L317.425 172.224ZM315.796 172.898L329.317 176.609L319.814 181.133L319.816 181.135L319.812 181.134L319.885 181.099L321.289 180.431L315.796 172.898ZM338.282 188.378L324.58 184.616L330.331 192.163L338.282 188.378Z",
    fill: "url(#paint0_linear_1137_494)",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Strommast mit Kabel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mast_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mast_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M306.7 174.466L328.53 161.862L350.359 174.466L328.53 187.069L306.7 174.466Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M306.7 174.466V187.069L328.53 199.674V187.069L306.7 174.466Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M328.53 199.674L350.359 187.069V174.466L328.53 187.069V199.674Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M328.53 144.686V141.882L345.504 151.806V154.486L328.53 144.686Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M328.53 141.882L330.957 140.48L345.504 149.269V151.806L328.53 141.882Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M326.102 163.26V93.9387L328.53 95.3406V164.662L326.102 163.26Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M330.957 163.26V93.9387L328.53 95.3406V164.662L330.957 163.26Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M328.53 123.004V120.201L345.504 130.005V132.803L328.53 123.004Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M328.53 120.201L330.957 118.799L345.504 127.588V130.123L328.53 120.201Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M328.53 144.686V141.882L311.556 151.806V154.486L328.53 144.686Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M328.53 141.882L326.102 140.48L311.556 149.269V151.806L328.53 141.882Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M328.53 123.004V120.201L311.556 130.123V132.803L328.53 123.004Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M328.53 120.201L326.102 118.799L311.556 127.588V130.123L328.53 120.201Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M306.7 174.467V105.147L309.128 106.549V175.869L306.7 174.467Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M311.555 174.467V105.147L309.128 106.549V175.869L311.555 174.467Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M326.102 185.668V116.348L328.53 117.75V187.07L326.102 185.668Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M330.958 185.667L330.928 113.553L328.499 114.955L328.53 187.069L330.958 185.667Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M345.504 174.467V105.147L347.932 106.549V175.869L345.504 174.467Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M350.359 174.467L350.326 102.407L347.898 103.809L347.932 175.869L350.359 174.467Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M328.53 72.933V70.1291L345.504 79.9339V82.732L328.53 72.933Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M328.53 70.1289L330.957 68.727L345.504 77.5149V80.0515L328.53 70.1289Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M328.53 95.4464V92.6426L345.504 102.447V105.247L328.53 95.4464Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M328.53 92.6429L330.957 91.241L345.504 100.03V102.567L328.53 92.6429Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M309.128 155.893V153.089L326.102 163.013V165.693L309.128 155.893Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M309.128 153.089L311.555 151.687L326.102 160.476V163.013L309.128 153.089Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M309.128 134.211V131.407L326.102 141.331V144.012L309.128 134.211Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M309.128 131.407L311.555 130.005L326.102 138.795V141.331L309.128 131.407Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M347.932 156.011V153.208L330.957 163.131V165.811L347.932 156.011Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M347.932 153.208L345.504 151.806L330.957 160.594V163.131L347.932 153.208Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M347.932 134.329V131.525L330.957 141.449V144.13L347.932 134.329Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M347.932 131.525L345.504 130.123L330.957 138.913V141.449L347.932 131.525Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M347.932 106.588L347.897 103.767L328.559 114.954L328.557 117.734L347.932 106.588Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M350.359 102.343L347.93 100.941L326.131 113.553L328.559 114.955L350.359 102.343Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M328.53 95.39L328.473 92.56L309.128 103.752L309.126 106.547L328.53 95.39Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M330.928 91.139L328.499 89.7385L306.7 102.35L309.128 103.752L330.928 91.139Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M306.712 105.246V79.9208L309.141 81.3228V106.648L306.712 105.246Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M311.569 102.375V79.9208L309.141 81.3228V103.777L311.569 102.375Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M326.019 91.1755L326.025 68.666L328.48 70.0854V92.5963L326.019 91.1755Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M330.908 91.1958V68.6834L328.48 70.0853V92.5963L330.908 91.1958Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M330.908 71.4539V68.6805L309.141 81.3227V84.0612L330.908 71.4539Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M330.908 68.6805L328.443 67.2582L306.712 79.9207L309.141 81.3227L330.908 68.6805Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M326.128 113.602V91.148L328.557 92.5499V115.004L326.128 113.602Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M330.985 113.602V91.148L328.557 92.5499V115.004L330.985 113.602Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M345.436 102.403L345.442 79.8946L347.897 81.3125V103.825L345.436 102.403Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M350.325 102.423V79.9106L347.897 81.3125V103.825L350.325 102.423Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M350.361 82.729L350.325 79.9077L328.557 92.5499V95.2884L350.361 82.729Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M350.325 79.9077L347.861 78.4854L326.128 91.1479L328.557 92.5498L350.325 79.9077Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M309.128 106.653V103.85L326.102 113.774V116.454L309.128 106.653Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M309.128 103.849L311.555 102.448L326.102 111.237V113.773L309.128 103.849Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M309.128 84.1395V81.3356L326.102 91.2582V93.9386L309.128 84.1395Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M309.128 81.3359L311.555 79.934L326.102 88.7233V91.2584L309.128 81.3359Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M306.712 79.9105V57.4562L309.141 58.8582V81.3124L306.712 79.9105Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M311.569 79.9105V57.4562L309.141 58.8582V81.3124L311.569 79.9105Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M326.019 68.7112L326.025 46.2017L328.48 47.6211V70.132L326.019 68.7112Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M330.908 68.73V46.2191L328.48 47.6211V70.132L330.908 68.73Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M375.663 22.8685V20.0966L262.277 86.0051V88.7436L375.663 22.8685Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M330.908 46.2162L328.443 44.7939L306.712 57.4564L309.141 58.8584L330.908 46.2162Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M375.674 20.0704L373.209 18.6467L259.861 84.5813L262.288 85.9833L375.674 20.0704Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M328.48 50.4247V47.6208L345.455 57.4256V60.2252L328.48 50.4247Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M328.48 47.6211L330.908 46.2191L347.861 56.0211L345.455 57.545L328.48 47.6211Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M375.834 22.7345L375.799 19.9132L330.811 23.8125V26.551L375.834 22.7345Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M375.798 19.9106L373.021 18.6772L328.38 22.4138L330.809 23.8142L375.798 19.9106Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M309.141 61.6622V58.8583L326.031 68.637L323.811 69.9241L309.141 61.6622Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M309.141 58.8583L311.449 57.497L328.443 67.3353L326.195 68.7314L309.141 58.8583Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M306.617 57.5622V35.1079L309.045 36.5098V58.9641L306.617 57.5622Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M311.473 57.5622V35.1079L309.045 36.5098V58.9641L311.473 57.5622Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M325.923 46.3629L325.931 23.8549L328.384 25.2728V47.7851L325.923 46.3629Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M330.814 46.3832V23.8708L328.385 25.2728V47.7852L330.814 46.3832Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M330.813 26.6413V23.868L309.045 36.5101V39.2486L330.813 26.6413Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M330.814 23.868L328.348 22.4457L306.617 35.1082L309.045 36.5101L330.814 23.868Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M343.235 41.9505V39.1467L360.291 49.0198L358.191 50.121L343.235 41.9505Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M343.235 39.1467L345.545 37.7855L362.538 47.6237L360.291 49.0199L343.235 39.1467Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M359.021 32.4582V29.6543L376.077 39.5274L374.464 41.1313L359.021 32.4582Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M359.021 29.6543L361.331 28.293L378.324 38.1313L376.077 39.5274L359.021 29.6543Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M373.369 24.022V21.2181L390.424 31.0913L390.369 33.914L373.369 24.022Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M373.369 21.2181L375.679 19.8569L392.672 29.6951L390.424 31.0913L373.369 21.2181Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M326.128 91.1377V68.6834L328.557 70.0853V92.5396L326.128 91.1377Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M330.985 91.1377V68.6834L328.557 70.0853V92.5396L330.985 91.1377Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M345.436 79.9383L345.442 57.4303L347.897 58.8482V81.3606L345.436 79.9383Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M350.325 79.9587V57.4463L347.897 58.8482V81.3606L350.325 79.9587Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M395.114 34.1433L395.079 31.3234L281.693 97.232V99.9704L395.114 34.1433Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M395.077 31.3208L392.301 30.0859L279.264 95.8317L281.692 97.2337L395.077 31.3208Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M395.114 34.1433L395.079 31.3234L350.091 35.2227V37.9612L395.114 34.1433Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M395.078 31.3207L392.672 29.6951L347.66 33.8224L350.088 35.2244L395.078 31.3207Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M328.48 28.2683V25.4644L345.455 35.2693V38.0673L328.48 28.2683Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M328.48 25.4646L330.908 24.0627L347.861 33.8646L345.455 35.3871L328.48 25.4646Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M326.034 68.7893V46.3351L328.462 47.737V70.1913L326.034 68.7893Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M330.889 68.7893V46.3351L328.461 47.737V70.1913L330.889 68.7893Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M345.34 57.59L345.347 35.082L347.801 36.4999V59.0123L345.34 57.59Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M350.23 57.6104V35.098L347.801 36.5V59.0123L350.23 57.6104Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M350.265 37.9164L350.23 35.0966L328.461 47.7372V50.4757L350.265 37.9164Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M350.23 35.0966L347.765 33.6729L326.034 46.3353L328.462 47.7373L350.23 35.0966Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M309.046 39.2834V36.4795L326.034 46.3047V49.1609L309.046 39.2834Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M309.046 36.4795L311.355 35.1182L328.348 44.9565L326.101 46.3526L309.046 36.4795Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M306.617 35.1387V12.6844L309.046 14.0864V36.5406L306.617 35.1387Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M311.474 35.1387V12.6844L309.046 14.0864V36.5406L311.474 35.1387Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M325.925 23.939L325.931 1.43103L328.386 2.84895V25.3613L325.925 23.939Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M330.814 23.9594V1.44702L328.386 2.84896V25.3613L330.814 23.9594Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M330.813 4.21753V1.44562L309.046 14.0863V16.8248L330.813 4.21753Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M330.814 1.44558L328.348 0.0218506L306.617 12.6843L309.046 14.0863L330.814 1.44558Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M328.297 5.64549V2.84161L345.27 12.6465V15.4445L328.297 5.64549Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M328.297 2.84182L330.725 1.43988L347.676 11.2418L345.27 12.7643L328.297 2.84182Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M326.034 46.3659V23.9116L328.463 25.3136V47.7678L326.034 46.3659Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M330.89 46.3659V23.9116L328.463 25.3136V47.7678L330.89 46.3659Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M345.342 35.1662L345.347 12.6582L347.803 14.0761V36.5885L345.342 35.1662Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M350.23 35.1866V12.6742L347.802 14.0761V36.5885L350.23 35.1866Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M350.266 15.4926L350.23 12.6727L328.463 25.3134V28.0519L350.266 15.4926Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M350.23 12.6728L347.765 11.249L326.034 23.9115L328.463 25.3134L350.23 12.6728Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M309.003 16.8815V14.0791L325.99 23.9043V26.7605L309.003 16.8815Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M309.003 14.079L311.311 12.7178L328.305 22.5546L326.059 23.9507L309.003 14.079Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M259.854 87.3502L259.861 84.5884L262.289 85.9904L262.281 88.7521L259.854 87.3502Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M279.258 98.5962L279.266 95.8345L281.695 97.2364L281.686 99.9982L279.258 98.5962Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M309.084 36.5593L306.619 35.137L259.861 84.5811L262.288 85.9831L309.084 36.5593Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M309.029 39.3503V36.5784L262.277 86.0051V88.7436L309.029 39.3503Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M293.198 70.8246V68.0222L310.254 77.8939L308.155 78.9966L293.198 70.8246Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M293.198 68.0226L295.508 66.6613L312.501 76.4981L310.254 77.8943L293.198 68.0226Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M275.336 81.1631V78.3592L292.392 88.2323L290.779 89.8362L275.336 81.1631Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M275.336 78.3591L277.646 76.9979L294.639 86.8361L292.392 88.2323L275.336 78.3591Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M262.26 88.7043V85.9005L279.314 95.7736L279.259 98.5963L262.26 88.7043Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M262.26 85.9004L264.568 84.5406L281.561 94.3774L279.314 95.7735L262.26 85.9004Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M328.511 47.8272L326.046 46.405L279.288 95.8491L281.715 97.251L328.511 47.8272Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M328.454 50.618V47.8461L281.704 97.2727V100.011L328.454 50.618Z",
    fill: "#747773"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Haus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haus_Photo_Klein"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M176.466 141.275L152.323 154.847V123.979L176.466 110.406V141.275Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M152.324 123.979L174.99 110.856L173.798 110.259L151.131 123.384V154.253L152.324 154.849V123.979Z",
    fill: "#050A29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M173.276 140.605L172.14 139.904L153.293 150.671V152.237L173.276 140.605Z",
    fill: "#B6B3AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M173.274 140.604L172.157 139.935V114.061L173.203 113.391L173.274 140.604Z",
    fill: "#B6B3AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M193.339 148.509V87.9653L108.557 136.878V197.421L119.07 191.382V144.259L139.127 132.702V179.825L193.339 148.509ZM178.357 111.079V143.587L154.412 157.533V125.022L178.357 111.079Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M118.772 144.184L137.412 133.446L136.816 133.222L118.251 143.961V188.251L118.772 188.475L118.772 144.184Z",
    fill: "#D5D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M134.058 157.456L133.461 157.755V177.439L120.338 184.749V185.271L133.984 177.666L134.058 157.456Z",
    fill: "#D5D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M134.058 137.846L133.461 138.145V155.217L120.338 162.748V163.269L133.982 155.44L134.058 137.846Z",
    fill: "#D5D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M136.368 178.26L137.338 177.738V133.448L118.697 144.185V188.475L130.775 181.541L123.991 185.417L136.368 178.26ZM133.983 177.662L120.337 185.267V165.209L133.906 157.455L133.983 177.662ZM133.983 137.846V155.514L120.487 163.343V145.676L133.983 137.846Z",
    fill: "#E7EBE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M118.697 144.633L142.781 130.838L142.26 130.614L118.25 144.334V191.979L118.697 192.202V144.633Z",
    fill: "#94ACB0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M140.395 179.824L138.829 179.079V136.132L140.395 135.387V179.824Z",
    fill: "#85879D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M138.903 178.484L137.337 177.514V137.097L138.903 136.127V178.484Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M148.821 184.894L131.373 194.883L119.517 188.023L136.89 178.036L148.821 184.894Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M131.447 194.883L119.517 188.031V188.702L131.447 195.562L148.82 185.573V184.895L131.447 194.883Z",
    fill: "#81959F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M142.782 130.838L118.697 144.632V192.201L121.601 190.561V190.417L121.527 146.128L140.316 135.391V179.829L142.702 178.486L142.782 130.838Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M65.162 169.536L91.3323 184.597V133.443L63.6583 116.987L65.162 169.536Z",
    fill: "#81959F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M91.3327 133.448L65.1618 118.466L66.3546 117.795L92.5255 132.777V183.926L91.3327 184.597V133.448Z",
    fill: "#0E166B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M66.951 168.418L68.1438 167.746L90.3636 180.274V181.915L66.951 168.418Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M66.9515 168.417L68.1443 167.746V121.668L66.9515 120.996V168.417Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M180.037 111.07V147.122L175.065 145.193L175.065 113.092L180.037 111.07Z",
    fill: "#B6B3AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M67.6229 72.1572L113.926 145.228L119.965 148.732L65.3117 61.6443L34.8902 99.4466L46.2983 102.057L67.6229 72.1572Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M65.3109 61.6443L119.965 148.734L206.68 99.5971L151.131 13.4042L65.3109 61.6443Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M178.346 143.663L174.991 141.725L154.337 153.655V157.603L178.346 143.663Z",
    fill: "#E7EBE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M46.2982 102.059V162.006L62.9259 171.181L63.6018 117.896L90.4397 132.927V186.984L108.557 197.423V136.754L67.6228 72.1586L46.2982 102.059Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M62.9247 171.176L65.1615 169.611L65.1615 118.773L62.8502 117.43L62.9247 171.176Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Photovoltaik"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M151.754 15.2391L124.94 30.7089L175.254 111.887L202.878 95.9037L151.754 15.2391Z",
    fill: "#D5C5E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M176.873 56.4189L151.753 71.0784L176.432 109.976L201.551 95.2436L176.873 56.4189Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M156.174 76.087L160.226 73.7301C160.368 73.6497 160.492 73.5423 160.592 73.4139C160.692 73.2855 160.766 73.1387 160.809 72.9818C160.852 72.8249 160.864 72.6611 160.844 72.4996C160.824 72.3382 160.772 72.1823 160.692 72.0408C160.663 71.9897 160.63 71.9408 160.594 71.8944L158.458 68.506C158.288 68.3094 158.055 68.1794 157.798 68.1389C157.542 68.0984 157.279 68.1501 157.058 68.2848L152.785 70.7894C152.585 70.8828 152.428 71.049 152.345 71.2543C152.263 71.4596 152.262 71.6885 152.343 71.8944L154.775 75.651C154.917 75.8793 155.137 76.049 155.394 76.129C155.65 76.209 155.928 76.1941 156.174 76.087Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M162.508 72.4766L166.56 70.1203C166.846 69.9579 167.055 69.6887 167.143 69.3718C167.23 69.0549 167.188 68.7163 167.026 68.4304C166.997 68.3794 166.965 68.3307 166.928 68.2846L164.792 64.8956C164.622 64.699 164.389 64.569 164.132 64.5285C163.876 64.488 163.614 64.5397 163.392 64.6744L159.119 67.179C158.918 67.2726 158.761 67.439 158.679 67.6444C158.597 67.8498 158.596 68.0788 158.677 68.2846L161.108 72.0412C161.247 72.2731 161.467 72.4456 161.725 72.5259C161.984 72.6062 162.262 72.5887 162.508 72.4766V72.4766Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M159.783 81.5376L163.835 79.1806C163.976 79.1003 164.101 78.9928 164.201 78.8645C164.301 78.7361 164.374 78.5893 164.418 78.4324C164.461 78.2755 164.473 78.1117 164.453 77.9502C164.432 77.7888 164.381 77.6329 164.3 77.4914C164.272 77.4405 164.239 77.3918 164.203 77.3456L162.067 73.9565C161.897 73.76 161.663 73.63 161.407 73.5895C161.151 73.549 160.888 73.6007 160.666 73.7354L156.394 76.24C156.194 76.3335 156.036 76.4998 155.954 76.7052C155.872 76.9106 155.871 77.1396 155.952 77.3456L158.384 81.1022C158.526 81.3307 158.745 81.5004 159.002 81.5803C159.259 81.6603 159.536 81.6451 159.783 81.5376V81.5376Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M166.12 77.9275L170.172 75.5717C170.458 75.4092 170.667 75.1398 170.755 74.8228C170.842 74.5058 170.8 74.1672 170.637 73.8813C170.608 73.8304 170.576 73.7817 170.54 73.7355L168.404 70.3464C168.234 70.1499 168 70.0199 167.744 69.9794C167.488 69.9389 167.225 69.9906 167.003 70.1253L162.73 72.6299C162.53 72.7234 162.373 72.8898 162.291 73.0952C162.209 73.3006 162.208 73.5296 162.289 73.7355L164.72 77.4921C164.862 77.7204 165.082 77.89 165.339 77.9699C165.596 78.0499 165.873 78.0348 166.12 77.9275Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M168.771 68.7935L172.823 66.4371C173.109 66.2755 173.319 66.0069 173.408 65.6903C173.496 65.3736 173.455 65.0349 173.294 64.7485C173.263 64.695 173.229 64.6438 173.191 64.5953L171.054 61.2068C170.885 61.0105 170.651 60.8805 170.395 60.84C170.139 60.7996 169.877 60.8512 169.655 60.9857L165.382 63.4903C165.181 63.5836 165.024 63.7499 164.942 63.9552C164.86 64.1605 164.859 64.3894 164.94 64.5953L167.371 68.3518C167.513 68.5813 167.732 68.7522 167.989 68.8333C168.246 68.9144 168.523 68.9003 168.771 68.7935V68.7935Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M175.107 65.1853L179.158 62.8283C179.299 62.748 179.424 62.6405 179.524 62.5122C179.624 62.3838 179.697 62.237 179.74 62.0801C179.784 61.9232 179.796 61.7594 179.775 61.5979C179.755 61.4364 179.704 61.2805 179.623 61.1391C179.594 61.088 179.562 61.0391 179.526 60.9927L177.388 57.5968C177.218 57.4004 176.984 57.2704 176.728 57.2299C176.472 57.1895 176.209 57.2411 175.987 57.3756L171.715 59.8802C171.515 59.9737 171.357 60.14 171.275 60.3454C171.193 60.5508 171.192 60.7798 171.272 60.9858L173.704 64.7424C173.854 64.963 174.074 65.1267 174.329 65.207C174.583 65.2874 174.857 65.2797 175.107 65.1853V65.1853Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M172.381 74.2442L176.432 71.8885C176.719 71.7268 176.929 71.4581 177.017 71.1413C177.106 70.8246 177.065 70.4857 176.903 70.1993C176.873 70.1459 176.838 70.0947 176.801 70.046L174.664 66.6576C174.495 66.4613 174.261 66.3314 174.005 66.2911C173.748 66.2507 173.486 66.3024 173.264 66.4371L168.991 68.9404C168.791 69.0339 168.634 69.2003 168.551 69.4058C168.469 69.6112 168.469 69.8402 168.55 70.0461L170.981 73.8026C171.122 74.0321 171.342 74.203 171.599 74.284C171.856 74.3651 172.133 74.351 172.381 74.2442Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M178.715 70.6353L182.767 68.2783C183.053 68.116 183.262 67.8469 183.35 67.5301C183.437 67.2134 183.395 66.8749 183.233 66.589C183.204 66.5381 183.171 66.4892 183.136 66.4427L180.999 63.0542C180.829 62.8577 180.596 62.7277 180.339 62.6872C180.083 62.6467 179.821 62.6984 179.599 62.8331L175.326 65.3377C175.126 65.431 174.968 65.5973 174.886 65.8026C174.804 66.0079 174.804 66.2369 174.885 66.4427L177.316 70.1992C177.458 70.4275 177.678 70.5971 177.934 70.6772C178.191 70.7572 178.468 70.7423 178.715 70.6353V70.6353Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M163.32 87.0632L167.371 84.7062C167.658 84.5447 167.868 84.2762 167.956 83.9597C168.045 83.6431 168.004 83.3045 167.842 83.0182C167.812 82.9647 167.778 82.9135 167.74 82.865L165.601 79.4746C165.431 79.2783 165.198 79.1483 164.941 79.1078C164.685 79.0673 164.423 79.1189 164.201 79.2535L159.928 81.7581C159.728 81.8516 159.57 82.018 159.488 82.2234C159.406 82.4288 159.406 82.6578 159.486 82.8637L161.918 86.6203C162.046 86.8635 162.265 87.0463 162.528 87.1292C162.79 87.2121 163.075 87.1883 163.32 87.0632Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M169.655 83.453L173.706 81.0967C173.848 81.0164 173.972 80.9089 174.072 80.7805C174.172 80.6521 174.246 80.5052 174.289 80.3483C174.332 80.1914 174.344 80.0274 174.324 79.8659C174.304 79.7044 174.252 79.5484 174.172 79.4068C174.143 79.3561 174.11 79.3074 174.075 79.2611L171.938 75.872C171.768 75.6755 171.535 75.5454 171.278 75.505C171.022 75.4645 170.76 75.5162 170.538 75.6509L166.265 78.1555C166.065 78.2489 165.907 78.4153 165.825 78.6207C165.743 78.8262 165.742 79.0552 165.823 79.2611L168.255 83.0177C168.394 83.2495 168.613 83.4221 168.872 83.5024C169.13 83.5827 169.409 83.5651 169.655 83.453V83.453Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M166.856 92.6609L170.908 90.3046C171.05 90.2246 171.174 90.1174 171.275 89.9893C171.375 89.8611 171.449 89.7145 171.493 89.5577C171.536 89.4009 171.549 89.237 171.529 89.0754C171.509 88.9138 171.458 88.7577 171.378 88.6159C171.348 88.5624 171.314 88.5112 171.276 88.4627L169.139 85.0743C168.97 84.8779 168.736 84.748 168.48 84.7075C168.223 84.667 167.961 84.7186 167.739 84.8531L163.466 87.3577C163.266 87.4511 163.109 87.6174 163.027 87.8227C162.944 88.028 162.944 88.2569 163.025 88.4627L165.456 92.2193C165.594 92.4523 165.813 92.6261 166.071 92.7076C166.33 92.7891 166.609 92.7725 166.856 92.6609V92.6609Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M173.19 89.0513L177.242 86.6943C177.383 86.6141 177.508 86.5067 177.608 86.3783C177.708 86.2499 177.782 86.1031 177.825 85.9462C177.868 85.7894 177.88 85.6255 177.86 85.464C177.84 85.3025 177.788 85.1466 177.708 85.0051C177.679 84.9542 177.646 84.9053 177.611 84.8587L175.474 81.4702C175.304 81.2737 175.07 81.1437 174.814 81.1032C174.558 81.0627 174.296 81.1144 174.074 81.2491L169.801 83.7537C169.6 83.847 169.443 84.0133 169.361 84.2186C169.279 84.424 169.278 84.6529 169.359 84.8587L171.79 88.6153C171.917 88.8583 172.135 89.0411 172.396 89.1235C172.657 89.206 172.94 89.1814 173.183 89.055L173.19 89.0513Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M175.917 79.7699L179.968 77.4129C180.11 77.3326 180.234 77.2253 180.334 77.0969C180.434 76.9686 180.508 76.8217 180.551 76.6648C180.594 76.508 180.606 76.3441 180.586 76.1826C180.566 76.0211 180.514 75.8652 180.434 75.7237C180.405 75.6728 180.372 75.6239 180.337 75.5773L178.2 72.1888C178.03 71.9923 177.797 71.8623 177.54 71.8218C177.284 71.7813 177.022 71.833 176.8 71.9677L172.527 74.4723C172.327 74.5656 172.169 74.7319 172.087 74.9372C172.005 75.1426 172.004 75.3715 172.085 75.5773L174.517 79.3339C174.647 79.5752 174.866 79.756 175.128 79.8375C175.389 79.9191 175.673 79.8948 175.917 79.7699Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M182.251 76.1603L186.302 73.8034C186.444 73.723 186.568 73.6156 186.668 73.4872C186.768 73.3588 186.842 73.212 186.885 73.0551C186.928 72.8983 186.94 72.7344 186.92 72.5729C186.9 72.4115 186.848 72.2556 186.768 72.1141C186.739 72.063 186.706 72.0141 186.671 71.9677L184.534 68.5793C184.365 68.3826 184.131 68.2524 183.875 68.2117C183.619 68.1711 183.356 68.2228 183.134 68.3575L178.861 70.8621C178.661 70.9556 178.504 71.122 178.422 71.3274C178.339 71.5328 178.339 71.7618 178.419 71.9677L180.851 75.7243C180.99 75.9561 181.21 76.1287 181.468 76.2091C181.726 76.2895 182.004 76.2721 182.251 76.1603V76.1603Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M179.526 85.3684L183.578 83.0115C183.72 82.9315 183.844 82.8245 183.945 82.6963C184.045 82.5682 184.119 82.4217 184.163 82.2649C184.206 82.1081 184.219 81.9443 184.199 81.7828C184.179 81.6213 184.128 81.4652 184.048 81.3235C184.018 81.2697 183.984 81.2185 183.946 81.1702L181.807 77.7799C181.637 77.5836 181.404 77.4538 181.148 77.4134C180.891 77.373 180.629 77.4248 180.407 77.5594L176.135 80.064C175.934 80.1574 175.777 80.3238 175.695 80.5293C175.613 80.7347 175.612 80.9637 175.693 81.1696L178.124 84.9256C178.277 85.1423 178.497 85.303 178.751 85.3829C179.004 85.4629 179.276 85.4578 179.526 85.3684Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M185.862 81.7582L189.913 79.4019C190.054 79.3215 190.179 79.2141 190.279 79.0857C190.379 78.9572 190.453 78.8104 190.496 78.6534C190.539 78.4965 190.551 78.3326 190.531 78.1711C190.511 78.0095 190.459 77.8535 190.379 77.712C190.35 77.6612 190.317 77.6123 190.282 77.5656L188.144 74.1772C187.975 73.9809 187.741 73.851 187.485 73.8106C187.229 73.7701 186.967 73.8216 186.745 73.956L182.472 76.4606C182.271 76.5539 182.114 76.7202 182.032 76.9255C181.95 77.1309 181.949 77.3598 182.03 77.5656L184.461 81.3222C184.612 81.541 184.832 81.7029 185.086 81.7819C185.34 81.861 185.613 81.8526 185.862 81.7582V81.7582Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M170.244 98.1859L174.296 95.8296C174.582 95.668 174.792 95.3993 174.881 95.0827C174.969 94.7661 174.928 94.4274 174.767 94.141C174.736 94.0874 174.702 94.0362 174.664 93.9877L172.527 90.5993C172.358 90.4029 172.124 90.273 171.868 90.2325C171.612 90.192 171.35 90.2436 171.128 90.3782L166.855 92.8821C166.654 92.9756 166.497 93.142 166.415 93.3474C166.333 93.5528 166.332 93.7818 166.413 93.9877L168.844 97.7443C168.973 97.9867 169.192 98.1688 169.454 98.2514C169.716 98.334 169.999 98.3105 170.244 98.1859V98.1859Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M176.579 94.5763L180.631 92.2194C180.773 92.1394 180.897 92.0323 180.998 91.9042C181.098 91.7761 181.172 91.6295 181.216 91.4728C181.259 91.316 181.272 91.1522 181.252 90.9907C181.233 90.8292 181.181 90.6731 181.101 90.5314C181.071 90.4778 181.037 90.4266 180.999 90.3782L178.86 86.9878C178.69 86.7918 178.457 86.6621 178.201 86.6218C177.944 86.5814 177.682 86.633 177.461 86.7673L173.188 89.2719C172.987 89.3653 172.83 89.5317 172.748 89.7372C172.666 89.9426 172.665 90.1716 172.746 90.3775L175.177 94.1335C175.315 94.367 175.535 94.5414 175.793 94.6231C176.052 94.7049 176.332 94.6882 176.579 94.5763V94.5763Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M173.855 103.637L177.906 101.281C178.193 101.12 178.403 100.851 178.491 100.535C178.579 100.218 178.538 99.8792 178.377 99.5929C178.346 99.5393 178.312 99.4879 178.274 99.439L176.139 96.0512C175.969 95.8548 175.735 95.7249 175.479 95.6844C175.223 95.6439 174.96 95.6955 174.738 95.8301L170.466 98.3346C170.265 98.4276 170.108 98.5938 170.026 98.799C169.943 99.0043 169.943 99.2333 170.024 99.439L172.454 103.196C172.583 103.438 172.802 103.62 173.064 103.703C173.326 103.785 173.61 103.762 173.855 103.637Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M180.189 100.028L184.241 97.6708C184.527 97.5084 184.736 97.2393 184.824 96.9226C184.911 96.6058 184.869 96.2673 184.707 95.9815C184.678 95.9304 184.645 95.8815 184.609 95.8351L182.473 92.4467C182.303 92.2502 182.07 92.1201 181.813 92.0797C181.557 92.0392 181.295 92.0909 181.073 92.2256L176.8 94.7295C176.599 94.823 176.442 94.9894 176.36 95.1948C176.278 95.4003 176.277 95.6293 176.358 95.8351L178.789 99.5917C178.932 99.8201 179.151 99.9897 179.408 100.07C179.665 100.15 179.942 100.135 180.189 100.028Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M182.841 90.893L186.892 88.5361C187.034 88.4562 187.159 88.3491 187.259 88.221C187.359 88.093 187.434 87.9464 187.477 87.7896C187.521 87.6329 187.533 87.469 187.514 87.3075C187.494 87.1459 187.443 86.9898 187.363 86.8481C187.333 86.7945 187.298 86.7431 187.261 86.6942L185.124 83.3058C184.955 83.1094 184.721 82.9795 184.465 82.939C184.208 82.8985 183.946 82.9501 183.724 83.0846L179.451 85.5892C179.251 85.6825 179.093 85.8488 179.011 86.0542C178.929 86.2595 178.929 86.4884 179.01 86.6942L181.441 90.4508C181.582 90.6803 181.801 90.8513 182.059 90.9325C182.316 91.0137 182.593 90.9997 182.841 90.893V90.893Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M189.176 87.2843L193.228 84.9273C193.514 84.7652 193.723 84.4962 193.811 84.1795C193.898 83.8628 193.856 83.5244 193.694 83.2387C193.665 83.1876 193.632 83.1385 193.597 83.0917L191.46 79.7039C191.29 79.5074 191.057 79.3773 190.8 79.3369C190.544 79.2964 190.282 79.3481 190.06 79.4828L185.787 81.9874C185.587 82.0805 185.429 82.2467 185.347 82.4519C185.265 82.6572 185.264 82.886 185.345 83.0917L187.777 86.8483C187.916 87.0802 188.135 87.2528 188.393 87.3332C188.651 87.4136 188.93 87.3962 189.176 87.2843V87.2843Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M186.449 96.3452L190.501 93.9882C190.787 93.8256 190.996 93.5563 191.084 93.2393C191.171 92.9224 191.129 92.5837 190.967 92.2977C190.938 92.2471 190.905 92.1984 190.87 92.152L188.733 88.7635C188.563 88.567 188.33 88.437 188.074 88.3965C187.817 88.356 187.555 88.4077 187.333 88.5424L183.06 91.047C182.86 91.1403 182.702 91.3066 182.62 91.5119C182.538 91.7172 182.538 91.9462 182.619 92.152L185.05 95.9085C185.192 96.1369 185.412 96.3066 185.668 96.3867C185.925 96.4669 186.202 96.4521 186.449 96.3452V96.3452Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M192.786 92.7345L196.838 90.3782C196.979 90.2982 197.104 90.1912 197.204 90.0631C197.305 89.935 197.379 89.7884 197.423 89.6316C197.466 89.4749 197.479 89.311 197.459 89.1495C197.439 88.988 197.388 88.8319 197.308 88.6902C197.278 88.6365 197.244 88.5851 197.206 88.5364L195.067 85.1472C194.897 84.9508 194.664 84.8207 194.408 84.7801C194.151 84.7395 193.889 84.791 193.667 84.9255L189.394 87.4295C189.194 87.5229 189.037 87.6893 188.955 87.8948C188.872 88.1002 188.872 88.3292 188.953 88.5351L191.384 92.2916C191.525 92.5218 191.745 92.6934 192.002 92.7747C192.26 92.8561 192.538 92.8418 192.786 92.7345V92.7345Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M177.537 109.163L181.588 106.806C181.874 106.644 182.084 106.375 182.171 106.058C182.258 105.741 182.216 105.402 182.054 105.117C182.025 105.066 181.992 105.017 181.956 104.97L179.82 101.582C179.65 101.385 179.417 101.255 179.16 101.215C178.904 101.174 178.642 101.226 178.42 101.361L174.147 103.865C173.947 103.959 173.79 104.125 173.707 104.33C173.625 104.535 173.624 104.764 173.705 104.97L176.137 108.727C176.276 108.959 176.495 109.131 176.754 109.212C177.012 109.292 177.29 109.275 177.537 109.163V109.163Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M183.8 105.553L187.851 103.196C187.993 103.116 188.117 103.009 188.217 102.88C188.318 102.752 188.392 102.606 188.436 102.449C188.479 102.292 188.492 102.128 188.472 101.967C188.452 101.805 188.401 101.649 188.321 101.508C188.291 101.454 188.257 101.403 188.219 101.354L186.083 97.9653C185.913 97.7689 185.68 97.639 185.423 97.5985C185.167 97.558 184.905 97.6097 184.683 97.7442L180.411 100.249C180.21 100.342 180.053 100.508 179.97 100.714C179.888 100.919 179.887 101.148 179.968 101.354L182.4 105.11C182.541 105.34 182.76 105.511 183.017 105.592C183.274 105.673 183.552 105.659 183.8 105.553V105.553Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M190.133 101.869L194.184 99.5125C194.471 99.351 194.681 99.0823 194.769 98.7657C194.858 98.449 194.817 98.1102 194.655 97.8239C194.625 97.7705 194.591 97.7193 194.553 97.6706L192.416 94.2822C192.246 94.0858 192.013 93.9558 191.757 93.9154C191.5 93.8749 191.238 93.9265 191.016 94.0611L186.743 96.5656C186.543 96.6589 186.386 96.8252 186.303 97.0306C186.221 97.2359 186.221 97.4648 186.302 97.6706L188.733 101.427C188.871 101.66 189.09 101.834 189.349 101.916C189.607 101.997 189.886 101.98 190.133 101.869V101.869Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M196.395 98.2593L200.447 95.9023C200.732 95.74 200.942 95.4709 201.029 95.1541C201.117 94.8373 201.075 94.4988 200.913 94.213C200.883 94.1622 200.851 94.1135 200.815 94.0673L198.678 90.6782C198.509 90.4817 198.275 90.3517 198.019 90.3112C197.763 90.2707 197.501 90.3224 197.279 90.4571L193.006 92.9616C192.805 93.0551 192.648 93.2215 192.566 93.4269C192.484 93.6324 192.483 93.8614 192.564 94.0672L194.995 97.8238C195.137 98.0523 195.357 98.222 195.614 98.3019C195.871 98.3819 196.148 98.3667 196.395 98.2593V98.2593Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M174.885 57.7442L199.047 96.5651L174.885 57.7442Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M174.885 57.7442L199.047 96.5651L174.885 57.7442Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M173.338 58.7015L197.5 97.523L173.338 58.7015Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M173.338 58.7015L197.5 97.523L173.338 58.7015Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M168.697 61.4266L192.86 100.248L168.697 61.4266Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M168.697 61.4266L192.86 100.248L168.697 61.4266Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M167.15 62.4589L191.313 101.279L167.15 62.4589Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M167.15 62.4589L191.313 101.279L167.15 62.4589Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M162.509 65.037L186.671 103.858L162.509 65.037Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M162.509 65.037L186.671 103.858L162.509 65.037Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M160.888 66.0679L185.051 104.889L160.888 66.0679Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M160.888 66.0679L185.051 104.889L160.888 66.0679Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M156.246 68.6473L180.409 107.468L156.246 68.6473Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M156.246 68.6473L180.409 107.468L156.246 68.6473Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M154.7 69.678L178.863 108.499L154.7 69.678Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M154.7 69.678L178.863 108.499L154.7 69.678Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M176.948 56.3448L177.021 56.4189L151.753 71.0777L151.681 71.0042L176.948 56.3448Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M177.021 56.4189L177.094 56.4924L151.901 71.1519V71.0049L177.021 56.4189Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M151.754 71.0764L151.68 71.0035L176.137 110.046L176.432 110.193L151.754 71.0764Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M151.754 71.0764L151.9 71.0035L176.578 110.119L176.432 110.193L151.754 71.0764Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M176.947 56.6387L176.8 56.7122L201.551 95.3804L201.772 95.4539L176.947 56.6387Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M176.874 56.4923L177.02 56.3453L201.92 95.3144L201.773 95.4614L176.874 56.4923Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M201.551 95.2398H201.697L176.504 110.042V109.895L201.551 95.2398Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M201.699 95.2398L201.772 95.4609L176.579 110.121L176.506 110.047L201.699 95.2398Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M124.939 30.7088L124.056 31.9608L174.37 113.139L175.253 111.887L124.939 30.7088Z",
    fill: "#3D3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M175.252 111.888L174.369 113.14L201.625 97.2283L202.877 95.9016L175.252 111.888Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M151.827 16.9338L126.782 31.5938L151.459 70.4147L176.505 55.6811L151.827 16.9338Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M131.202 36.6019L135.253 34.2456C135.54 34.0841 135.75 33.8154 135.838 33.4988C135.927 33.1821 135.886 32.8433 135.724 32.557C135.694 32.5035 135.66 32.4522 135.622 32.4037L133.486 29.0153C133.316 28.8189 133.082 28.6889 132.826 28.6485C132.57 28.608 132.307 28.6596 132.085 28.7942L127.812 31.2987C127.612 31.3921 127.455 31.5584 127.373 31.7637C127.291 31.9691 127.29 32.1979 127.371 32.4037L129.802 36.1603C129.952 36.3802 130.172 36.5434 130.426 36.6235C130.68 36.7036 130.953 36.696 131.202 36.6019V36.6019Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M137.463 32.9189L141.514 30.5613C141.656 30.481 141.78 30.3735 141.88 30.2451C141.98 30.1167 142.054 29.9698 142.098 29.8129C142.141 29.656 142.153 29.492 142.133 29.3305C142.113 29.169 142.061 29.013 141.98 28.8714C141.952 28.8206 141.919 28.7719 141.883 28.7257L139.747 25.3366C139.577 25.1401 139.343 25.01 139.087 24.9695C138.831 24.9291 138.568 24.9808 138.346 25.1155L134.074 27.6201C133.873 27.7136 133.716 27.88 133.634 28.0854C133.552 28.2908 133.551 28.5198 133.632 28.7257L136.063 32.4823C136.205 32.7108 136.425 32.8807 136.682 32.9608C136.939 33.041 137.216 33.0261 137.463 32.9189V32.9189Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M134.812 42.0541L138.863 39.6972C139.005 39.6168 139.129 39.5094 139.229 39.381C139.329 39.2526 139.403 39.1057 139.446 38.9488C139.49 38.7918 139.501 38.6279 139.481 38.4664C139.461 38.3048 139.41 38.1488 139.329 38.0073C139.301 37.9563 139.268 37.9076 139.232 37.8615L137.095 34.4725C136.926 34.2759 136.692 34.1459 136.436 34.1054C136.18 34.0649 135.917 34.1166 135.695 34.2513L131.422 36.7559C131.222 36.8495 131.065 37.0159 130.983 37.2213C130.901 37.4267 130.9 37.6556 130.981 37.8615L133.412 41.6181C133.563 41.8368 133.783 41.9986 134.037 42.0776C134.29 42.1567 134.563 42.1484 134.812 42.0541V42.0541Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M141.145 38.3703L145.197 36.014C145.483 35.8516 145.692 35.5823 145.779 35.2654C145.867 34.9485 145.824 34.6099 145.662 34.3241C145.633 34.2731 145.601 34.2244 145.565 34.1784L143.428 30.7893C143.259 30.5928 143.025 30.4627 142.769 30.4222C142.512 30.3818 142.25 30.4335 142.028 30.5682L137.756 33.0728C137.555 33.1662 137.398 33.3326 137.316 33.538C137.234 33.7434 137.233 33.9724 137.314 34.1784L139.745 37.9349C139.872 38.1778 140.09 38.3605 140.351 38.4429C140.612 38.5254 140.895 38.5008 141.138 38.3747L141.145 38.3703Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M143.798 29.2356L147.849 26.8787C147.991 26.7984 148.115 26.691 148.215 26.5627C148.315 26.4343 148.389 26.2875 148.432 26.1306C148.476 25.9737 148.488 25.8099 148.467 25.6484C148.447 25.4869 148.396 25.3309 148.315 25.1894C148.286 25.1384 148.254 25.0894 148.218 25.043L146.082 21.6546C145.912 21.458 145.678 21.3279 145.422 21.2873C145.166 21.2467 144.903 21.2982 144.681 21.4329L140.408 23.9381C140.208 24.0315 140.051 24.1978 139.969 24.4031C139.887 24.6084 139.886 24.8373 139.967 25.043L142.398 28.7996C142.524 29.0426 142.742 29.2254 143.003 29.3079C143.264 29.3904 143.548 29.3657 143.791 29.2394L143.798 29.2356Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M150.06 25.6263L154.111 23.2694C154.253 23.1895 154.378 23.0824 154.478 22.9543C154.579 22.8263 154.653 22.6796 154.696 22.5229C154.74 22.3662 154.753 22.2023 154.733 22.0408C154.713 21.8792 154.662 21.7231 154.582 21.5814C154.552 21.5278 154.518 21.4766 154.48 21.4281L152.341 18.0384C152.172 17.842 151.938 17.712 151.682 17.6714C151.426 17.6308 151.163 17.6823 150.942 17.8167L146.668 20.3219C146.468 20.4153 146.31 20.5816 146.228 20.7869C146.146 20.9922 146.146 21.2211 146.226 21.4269L148.658 25.1835C148.799 25.4137 149.019 25.5852 149.277 25.6665C149.534 25.7479 149.812 25.7336 150.06 25.6263V25.6263Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M147.407 34.6872L151.459 32.3303C151.601 32.2499 151.725 32.1425 151.825 32.0141C151.925 31.8857 151.998 31.7389 152.042 31.582C152.085 31.4252 152.097 31.2613 152.077 31.0999C152.056 30.9384 152.005 30.7825 151.924 30.641C151.896 30.5899 151.863 30.541 151.827 30.4947L149.691 27.1062C149.521 26.9097 149.287 26.7796 149.031 26.7391C148.775 26.6987 148.512 26.7504 148.29 26.8851L144.017 29.3897C143.817 29.4831 143.66 29.6494 143.578 29.8547C143.496 30.06 143.495 30.2888 143.576 30.4946L146.007 34.2512C146.133 34.4942 146.351 34.677 146.612 34.7595C146.873 34.842 147.157 34.8173 147.4 34.691L147.407 34.6872Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M153.743 31.0777L157.794 28.7207C158.08 28.5583 158.289 28.289 158.377 27.9721C158.464 27.6552 158.422 27.3166 158.259 27.0308C158.231 26.9798 158.198 26.9311 158.162 26.8851L156.024 23.4891C155.854 23.2928 155.621 23.1628 155.364 23.1223C155.108 23.0819 154.846 23.1335 154.624 23.268L150.351 25.7726C150.151 25.8659 149.993 26.0321 149.911 26.2374C149.829 26.4427 149.828 26.6716 149.908 26.8776L152.34 30.6342C152.478 30.8679 152.698 31.0424 152.957 31.1243C153.216 31.2061 153.495 31.1895 153.743 31.0777Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M138.347 47.5782L142.398 45.2219C142.54 45.1415 142.664 45.0341 142.764 44.9057C142.864 44.7773 142.938 44.6304 142.981 44.4735C143.024 44.3166 143.036 44.1526 143.016 43.9911C142.996 43.8296 142.944 43.6736 142.864 43.532C142.835 43.4811 142.803 43.4324 142.767 43.3863L140.63 39.9972C140.461 39.8007 140.227 39.6706 139.971 39.6301C139.714 39.5896 139.452 39.6414 139.23 39.7761L134.957 42.2807C134.757 42.3742 134.6 42.5406 134.517 42.746C134.435 42.9514 134.435 43.1804 134.516 43.3863L136.947 47.1428C137.086 47.3747 137.306 47.5473 137.564 47.6276C137.822 47.7079 138.101 47.6903 138.347 47.5782V47.5782Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M144.608 43.8953L148.66 41.5383C148.801 41.458 148.925 41.3505 149.025 41.2222C149.125 41.0938 149.199 40.9469 149.242 40.7901C149.285 40.6332 149.297 40.4694 149.277 40.3079C149.257 40.1465 149.205 39.9905 149.125 39.8491C149.096 39.7982 149.064 39.7494 149.028 39.7033L146.891 36.3149C146.722 36.1184 146.488 35.9883 146.232 35.9478C145.975 35.9073 145.713 35.959 145.491 36.0937L141.219 38.5977C141.018 38.6912 140.861 38.8576 140.779 39.063C140.697 39.2684 140.696 39.4974 140.776 39.7033L143.208 43.4599C143.35 43.6884 143.57 43.8581 143.827 43.938C144.084 44.018 144.361 44.0028 144.608 43.8953V43.8953Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M141.811 53.1033L145.862 50.7475C146.148 50.5859 146.359 50.3171 146.447 50.0004C146.535 49.6836 146.494 49.3448 146.333 49.0583C146.302 49.0048 146.268 48.9536 146.231 48.9051L144.094 45.5166C143.924 45.3202 143.691 45.1903 143.434 45.1498C143.178 45.1093 142.916 45.1609 142.694 45.2955L138.421 47.7995C138.22 47.893 138.063 48.0595 137.981 48.2649C137.899 48.4702 137.898 48.6992 137.979 48.9051L140.41 52.6616C140.539 52.9041 140.758 53.0862 141.02 53.1688C141.282 53.2514 141.566 53.2278 141.811 53.1033V53.1033Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M148.145 49.5671L152.196 47.2101C152.338 47.1302 152.463 47.0231 152.563 46.8951C152.663 46.767 152.738 46.6204 152.781 46.4637C152.825 46.3069 152.837 46.1431 152.818 45.9815C152.798 45.82 152.747 45.6639 152.667 45.5221C152.637 45.4686 152.603 45.4174 152.565 45.3689L150.429 41.9804C150.259 41.784 150.025 41.6541 149.769 41.6136C149.513 41.5731 149.25 41.6247 149.028 41.7593L144.755 44.2639C144.555 44.3573 144.398 44.5236 144.316 44.7289C144.234 44.9342 144.233 45.1631 144.314 45.3689L146.745 49.1254C146.898 49.3416 147.118 49.5018 147.371 49.5815C147.624 49.6612 147.895 49.6562 148.145 49.5671V49.5671Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M150.942 40.2862L154.993 37.9293C155.135 37.8489 155.259 37.7415 155.359 37.6131C155.459 37.4847 155.533 37.3378 155.576 37.1809C155.62 37.0239 155.631 36.86 155.611 36.6985C155.591 36.5369 155.54 36.3809 155.459 36.2394C155.43 36.1886 155.398 36.1399 155.362 36.0936L153.225 32.7045C153.056 32.5083 152.822 32.3784 152.566 32.338C152.309 32.2975 152.047 32.3491 151.825 32.4835L147.552 34.9881C147.352 35.0816 147.195 35.2481 147.113 35.4535C147.031 35.6588 147.03 35.8878 147.111 36.0937L149.542 39.8496C149.693 40.0684 149.913 40.2303 150.167 40.3094C150.42 40.3886 150.693 40.3804 150.942 40.2862V40.2862Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M157.205 36.602L161.256 34.2456C161.543 34.084 161.753 33.8153 161.841 33.4987C161.929 33.182 161.888 32.8433 161.727 32.557C161.697 32.5033 161.662 32.4521 161.624 32.4038L159.488 29.0153C159.318 28.819 159.085 28.6892 158.828 28.6487C158.572 28.6082 158.31 28.6598 158.088 28.7942L153.815 31.2988C153.615 31.3921 153.458 31.5584 153.375 31.7637C153.293 31.969 153.292 32.1979 153.373 32.4037L155.805 36.1603C155.946 36.3898 156.165 36.5607 156.422 36.6418C156.679 36.7229 156.957 36.7088 157.205 36.602V36.602Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M154.553 45.8104L158.604 43.4528C158.746 43.3725 158.87 43.2651 158.97 43.1366C159.07 43.0082 159.144 42.8614 159.187 42.7044C159.231 42.5475 159.243 42.3836 159.222 42.222C159.202 42.0605 159.151 41.9045 159.07 41.763C159.041 41.7122 159.009 41.6635 158.973 41.6172L156.837 38.2281C156.667 38.0316 156.433 37.9016 156.177 37.8611C155.921 37.8206 155.658 37.8723 155.436 38.007L151.163 40.5116C150.963 40.6052 150.806 40.7716 150.724 40.977C150.642 41.1824 150.641 41.4113 150.722 41.6172L153.153 45.3738C153.292 45.6058 153.511 45.7786 153.77 45.8591C154.028 45.9396 154.307 45.9223 154.553 45.8104V45.8104Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M160.815 42.2003L164.867 39.8421C165.009 39.7618 165.133 39.6543 165.233 39.5259C165.333 39.3976 165.406 39.2507 165.45 39.0939C165.493 38.937 165.505 38.7732 165.485 38.6117C165.465 38.4502 165.413 38.2943 165.332 38.1529C165.304 38.1018 165.271 38.0528 165.235 38.0065L163.099 34.618C162.929 34.4215 162.695 34.2915 162.439 34.251C162.183 34.2105 161.92 34.2622 161.699 34.3969L157.426 36.9015C157.226 36.9948 157.068 37.1611 156.986 37.3664C156.904 37.5717 156.903 37.8006 156.984 38.0065L159.416 41.763C159.558 41.9917 159.777 42.1616 160.034 42.2419C160.291 42.3222 160.568 42.3074 160.815 42.2003Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M145.272 58.7018L149.324 56.3448C149.465 56.2644 149.589 56.157 149.689 56.0286C149.789 55.9002 149.863 55.7534 149.906 55.5965C149.949 55.4397 149.961 55.2758 149.941 55.1144C149.921 54.9529 149.869 54.797 149.789 54.6555C149.76 54.6043 149.728 54.5554 149.692 54.5092L147.555 51.1201C147.386 50.9235 147.152 50.7935 146.896 50.753C146.639 50.7125 146.377 50.7642 146.155 50.8989L141.882 53.4035C141.682 53.4971 141.524 53.6635 141.442 53.8689C141.36 54.0743 141.36 54.3032 141.44 54.5091L143.871 58.2657C144.023 58.4844 144.243 58.6462 144.496 58.7252C144.75 58.8043 145.023 58.796 145.272 58.7018V58.7018Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M151.534 55.0193L155.584 52.6624C155.726 52.582 155.85 52.4746 155.95 52.3462C156.05 52.2178 156.124 52.0709 156.167 51.914C156.21 51.757 156.222 51.5931 156.202 51.4316C156.182 51.27 156.13 51.114 156.05 50.9725C156.021 50.9216 155.989 50.8729 155.953 50.8267L153.815 47.4308C153.645 47.2347 153.411 47.105 153.155 47.0645C152.899 47.024 152.636 47.0755 152.414 47.2097L148.142 49.7143C147.941 49.8076 147.784 49.9738 147.702 50.1791C147.619 50.3844 147.619 50.6133 147.699 50.8193L150.131 54.5758C150.272 54.8061 150.492 54.9777 150.75 55.0592C151.007 55.1407 151.286 55.1265 151.534 55.0193V55.0193Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M148.881 64.1538L152.932 61.7962C153.086 61.7082 153.22 61.5882 153.324 61.4444C153.427 61.3005 153.499 61.1361 153.534 60.9622C153.569 60.7883 153.566 60.609 153.526 60.4362C153.486 60.2634 153.409 60.1012 153.301 59.9606L151.165 56.5721C150.995 56.3757 150.761 56.2457 150.505 56.2054C150.249 56.165 149.986 56.2168 149.764 56.3516L145.492 58.8562C145.291 58.9495 145.134 59.1157 145.052 59.3209C144.97 59.5261 144.969 59.7549 145.05 59.9606L147.481 63.7172C147.632 63.9359 147.852 64.0978 148.106 64.177C148.36 64.2561 148.633 64.248 148.881 64.1538V64.1538Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M155.216 60.47L159.268 58.113C159.553 57.9506 159.763 57.6813 159.85 57.3644C159.938 57.0475 159.895 56.7089 159.733 56.4231C159.704 56.3722 159.672 56.3235 159.636 56.2774L157.497 52.8814C157.328 52.6853 157.094 52.5556 156.838 52.5151C156.582 52.4746 156.319 52.5261 156.097 52.6603L151.825 55.1649C151.624 55.2581 151.467 55.4244 151.385 55.6297C151.303 55.8351 151.302 56.064 151.383 56.2699L153.814 60.0265C153.875 60.1473 153.96 60.2548 154.064 60.3428C154.167 60.4307 154.286 60.4975 154.415 60.5393C154.544 60.5811 154.68 60.597 154.816 60.5861C154.951 60.5753 155.083 60.538 155.203 60.4762L155.216 60.47Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M157.868 51.3348L161.919 48.9784C162.205 48.8169 162.416 48.5483 162.504 48.2316C162.593 47.915 162.551 47.5762 162.39 47.2898C162.36 47.2363 162.326 47.1851 162.288 47.1366L160.151 43.7481C159.982 43.5517 159.748 43.4218 159.492 43.3813C159.235 43.3408 158.973 43.3924 158.751 43.527L154.478 46.031C154.278 46.1246 154.121 46.291 154.039 46.4964C153.957 46.7018 153.956 46.9307 154.037 47.1366L156.468 50.8932C156.593 51.1368 156.81 51.3207 157.071 51.4045C157.332 51.4882 157.615 51.465 157.859 51.3398L157.868 51.3348Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M164.13 47.7261L168.182 45.3691C168.323 45.2887 168.448 45.1813 168.548 45.0529C168.647 44.9245 168.721 44.7777 168.764 44.6209C168.808 44.464 168.819 44.3002 168.799 44.1387C168.779 43.9772 168.727 43.8213 168.647 43.6799C168.618 43.6288 168.586 43.5799 168.55 43.5335L166.413 40.1444C166.244 39.9479 166.01 39.8178 165.754 39.7773C165.497 39.7369 165.235 39.7886 165.013 39.9233L160.74 42.4279C160.54 42.5215 160.383 42.6879 160.301 42.8933C160.219 43.0987 160.218 43.3276 160.299 43.5335L162.73 47.2901C162.872 47.5184 163.092 47.688 163.349 47.768C163.606 47.848 163.883 47.8331 164.13 47.7261V47.7261Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M161.478 56.7862L165.529 54.4298C165.67 54.3495 165.795 54.242 165.895 54.1136C165.995 53.9852 166.069 53.8384 166.112 53.6814C166.155 53.5245 166.167 53.3606 166.147 53.199C166.127 53.0375 166.075 52.8815 165.995 52.74C165.966 52.689 165.934 52.6402 165.897 52.5942L163.761 49.2051C163.591 49.0086 163.358 48.8786 163.101 48.8381C162.845 48.7976 162.583 48.8493 162.361 48.984L158.088 51.4886C157.887 51.5821 157.73 51.7486 157.648 51.954C157.566 52.1594 157.565 52.3883 157.646 52.5942L160.077 56.3508C160.204 56.5936 160.422 56.7762 160.683 56.8586C160.944 56.9411 161.227 56.9166 161.47 56.7905L161.478 56.7862Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M167.813 53.1768L171.865 50.8198C172.006 50.7395 172.131 50.6321 172.23 50.5037C172.33 50.3753 172.404 50.2285 172.447 50.0716C172.491 49.9147 172.502 49.7509 172.482 49.5894C172.462 49.428 172.41 49.2721 172.33 49.1306C172.301 49.0795 172.269 49.0306 172.233 48.9842L170.096 45.5958C169.927 45.3993 169.693 45.2693 169.437 45.2288C169.181 45.1883 168.919 45.24 168.697 45.3747L164.424 47.8786C164.223 47.9721 164.066 48.1385 163.984 48.3439C163.902 48.5493 163.901 48.7783 163.982 48.9842L166.413 52.7408C166.539 52.9838 166.757 53.1666 167.018 53.2491C167.279 53.3316 167.562 53.3069 167.805 53.1805L167.813 53.1768Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M152.491 69.6046L156.542 67.2483C156.684 67.1679 156.808 67.0605 156.908 66.9321C157.008 66.8037 157.082 66.6568 157.125 66.4999C157.168 66.3429 157.18 66.179 157.16 66.0175C157.14 65.8559 157.088 65.6999 157.008 65.5584C156.979 65.5074 156.947 65.4587 156.911 65.4126L154.774 62.0242C154.605 61.8278 154.371 61.6978 154.115 61.6574C153.858 61.6169 153.596 61.6685 153.374 61.8031L149.101 64.3077C148.901 64.401 148.743 64.5673 148.661 64.7727C148.579 64.978 148.579 65.2068 148.66 65.4126L151.091 69.1692C151.221 69.4104 151.44 69.591 151.702 69.6724C151.964 69.7537 152.247 69.7294 152.491 69.6046V69.6046Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M158.826 65.9944L162.878 63.6381C163.164 63.4757 163.373 63.2064 163.461 62.8895C163.548 62.5726 163.506 62.234 163.343 61.9482C163.315 61.8972 163.282 61.8485 163.246 61.8025L161.11 58.4134C160.94 58.2171 160.706 58.0872 160.45 58.0468C160.194 58.0063 159.931 58.0578 159.709 58.1922L155.437 60.6968C155.236 60.7904 155.079 60.9568 154.997 61.1622C154.915 61.3676 154.914 61.5966 154.995 61.8025L157.426 65.559C157.565 65.7909 157.785 65.9634 158.043 66.0437C158.301 66.1241 158.58 66.1065 158.826 65.9944Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M165.087 62.3113L169.138 59.9556C169.425 59.7938 169.635 59.5251 169.723 59.2084C169.812 58.8917 169.771 58.5529 169.609 58.2664C169.579 58.2129 169.545 58.1616 169.507 58.1131L167.37 54.7247C167.2 54.5284 166.967 54.3985 166.71 54.3582C166.454 54.3178 166.192 54.3695 165.97 54.5042L161.698 57.0075C161.497 57.1011 161.34 57.2674 161.258 57.4728C161.176 57.6782 161.175 57.9072 161.255 58.1131L163.686 61.8697C163.828 62.0992 164.047 62.2701 164.304 62.3511C164.561 62.4322 164.839 62.4181 165.087 62.3113V62.3113Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M171.423 58.7024L175.474 56.3454C175.616 56.2652 175.74 56.1578 175.84 56.0294C175.94 55.9011 176.014 55.7543 176.057 55.5974C176.101 55.4405 176.113 55.2766 176.092 55.1151C176.072 54.9536 176.021 54.7977 175.94 54.6562C175.911 54.6052 175.879 54.5563 175.843 54.5098L173.704 51.1139C173.534 50.9175 173.301 50.7876 173.044 50.7471C172.788 50.7066 172.526 50.7582 172.304 50.8928L168.031 53.3973C167.83 53.4908 167.673 53.6572 167.591 53.8626C167.509 54.0681 167.508 54.2971 167.589 54.5029L170.02 58.2595C170.159 58.4931 170.378 58.6674 170.637 58.7492C170.896 58.8309 171.176 58.8142 171.423 58.7024V58.7024Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M149.912 18.186L174.074 57.0075L149.912 18.186Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M149.912 18.186L174.074 57.0075L149.912 18.186Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M148.365 19.2175L172.527 58.0383L148.365 19.2175Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M148.365 19.2175L172.527 58.0383L148.365 19.2175Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M143.724 21.9426L167.886 60.7641L143.724 21.9426Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M143.724 21.9426L167.886 60.7641L143.724 21.9426Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M142.104 22.9012L166.266 61.7227L142.104 22.9012Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M142.104 22.9012L166.266 61.7227L142.104 22.9012Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M137.463 25.5521L161.626 64.3736L137.463 25.5521Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M137.463 25.5521L161.626 64.3736L137.463 25.5521Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M135.915 26.5099L160.078 65.3308L135.915 26.5099Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M135.915 26.5099L160.078 65.3308L135.915 26.5099Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M131.275 29.1622L155.438 67.983L131.275 29.1622Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M131.275 29.1622L155.438 67.983L131.275 29.1622Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M129.728 30.119L153.89 68.9404L129.728 30.119Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M129.728 30.119L153.89 68.9404L129.728 30.119Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M151.901 16.7863L152.048 16.8598L126.781 31.5884L126.634 31.5149L151.901 16.7863Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M152.049 16.8591V17.0061L126.929 31.5927V31.5192L152.049 16.8591Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M126.781 31.592L126.634 31.5198L151.164 70.4876L151.46 70.6353L126.781 31.592Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M126.781 31.592L126.854 31.5198L151.532 70.6353H151.458L126.781 31.592Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M151.901 17.081L151.827 17.1545L176.578 55.8284L176.725 55.9025L151.901 17.081Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M151.828 16.9332L152.049 16.8597L176.949 55.7578L176.727 55.9048L151.828 16.9332Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M176.505 55.6819H176.652L151.532 70.4839L151.459 70.3363L176.505 55.6819Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M176.654 55.6813L176.726 55.9024L151.534 70.6359V70.4833L176.654 55.6813Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M123.54 31.3715L96.7252 46.9147L147.039 128.021L174.663 112.037L123.54 31.3715Z",
    fill: "#D5C5E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M148.659 72.5507L123.539 87.2843L148.217 126.106L173.336 111.372L148.659 72.5507Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M127.96 92.22L132.011 89.8637C132.153 89.7833 132.277 89.6759 132.377 89.5475C132.477 89.4191 132.551 89.2722 132.594 89.1152C132.637 88.9583 132.649 88.7944 132.629 88.6329C132.609 88.4714 132.557 88.3154 132.477 88.1738C132.448 88.1227 132.416 88.0738 132.38 88.0274L130.241 84.6321C130.072 84.4356 129.838 84.3056 129.582 84.2651C129.326 84.2246 129.063 84.2763 128.841 84.411L124.569 86.9156C124.368 87.0089 124.211 87.1751 124.129 87.3804C124.046 87.5857 124.045 87.8146 124.126 88.0206L126.558 91.7765C126.686 92.0199 126.906 92.2028 127.168 92.2858C127.431 92.3688 127.715 92.3452 127.96 92.22Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M134.295 88.6096L138.347 86.2527C138.489 86.1727 138.613 86.0656 138.714 85.9375C138.814 85.8094 138.888 85.6628 138.932 85.5061C138.976 85.3493 138.988 85.1855 138.968 85.024C138.949 84.8624 138.897 84.7064 138.817 84.5647C138.787 84.5108 138.753 84.4594 138.715 84.4108L136.579 81.0224C136.409 80.826 136.175 80.696 135.919 80.6555C135.663 80.6151 135.4 80.6667 135.179 80.8012L130.906 83.3058C130.706 83.3992 130.548 83.5654 130.466 83.7707C130.384 83.976 130.383 84.2049 130.464 84.4108L132.895 88.1674C133.033 88.4004 133.252 88.5743 133.511 88.6559C133.769 88.7375 134.048 88.721 134.295 88.6096Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M131.569 97.6707L135.621 95.3144C135.907 95.152 136.116 94.8827 136.203 94.5658C136.291 94.2489 136.248 93.9103 136.086 93.6245C136.057 93.5735 136.025 93.5248 135.989 93.4788L133.852 90.0897C133.683 89.8931 133.449 89.7631 133.193 89.7226C132.936 89.6821 132.674 89.7338 132.452 89.8685L128.18 92.3731C127.979 92.4666 127.822 92.633 127.74 92.8384C127.658 93.0438 127.657 93.2728 127.738 93.4787L130.169 97.2347C130.299 97.476 130.518 97.6568 130.78 97.7383C131.042 97.8198 131.325 97.7956 131.569 97.6707V97.6707Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M137.905 94.061L141.957 91.7028C142.098 91.6226 142.223 91.5152 142.323 91.3868C142.423 91.2585 142.496 91.1117 142.54 90.9548C142.583 90.7979 142.595 90.634 142.575 90.4725C142.555 90.311 142.503 90.1551 142.423 90.0136C142.394 89.9625 142.361 89.9135 142.325 89.8672L140.189 86.4787C140.019 86.2822 139.786 86.1522 139.529 86.1117C139.273 86.0712 139.01 86.1229 138.789 86.2576L134.516 88.7622C134.315 88.8556 134.158 89.0219 134.076 89.2272C133.994 89.4325 133.993 89.6614 134.074 89.8672L136.505 93.6238C136.635 93.8653 136.854 94.0463 137.116 94.128C137.378 94.2097 137.661 94.1857 137.905 94.061V94.061Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M140.557 84.9258L144.608 82.5695C144.894 82.408 145.105 82.1394 145.193 81.8227C145.281 81.506 145.24 81.1672 145.079 80.8809C145.049 80.8274 145.014 80.7762 144.977 80.7276L142.84 77.3392C142.671 77.1428 142.437 77.0128 142.181 76.9724C141.924 76.9319 141.662 76.9835 141.44 77.1181L137.167 79.6227C136.967 79.7161 136.809 79.8824 136.727 80.0877C136.645 80.293 136.645 80.5218 136.725 80.7276L139.157 84.4842C139.298 84.7137 139.517 84.8845 139.774 84.9656C140.032 85.0467 140.309 85.0326 140.557 84.9258V84.9258Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M146.892 81.3178L150.943 78.9608C151.085 78.8806 151.209 78.7733 151.309 78.645C151.409 78.5167 151.483 78.3699 151.526 78.2131C151.569 78.0563 151.581 77.8924 151.561 77.731C151.541 77.5695 151.489 77.4136 151.409 77.2722C151.38 77.2208 151.348 77.1716 151.312 77.1252L149.175 73.7374C149.006 73.5408 148.772 73.4108 148.516 73.3703C148.259 73.3298 147.997 73.3815 147.775 73.5162L143.502 76.0208C143.302 76.1141 143.145 76.2803 143.062 76.4855C142.98 76.6907 142.98 76.9195 143.061 77.1252L145.492 80.8818C145.631 81.1137 145.85 81.2863 146.109 81.3668C146.367 81.4472 146.646 81.4297 146.892 81.3178V81.3178Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M144.167 90.3781L148.218 88.0211C148.36 87.9412 148.484 87.8342 148.585 87.7061C148.685 87.578 148.759 87.4314 148.803 87.2747C148.847 87.1179 148.859 86.9541 148.839 86.7925C148.82 86.631 148.769 86.4749 148.689 86.3331C148.659 86.2793 148.624 86.2279 148.586 86.1793L146.448 82.7896C146.278 82.5932 146.044 82.4632 145.788 82.4227C145.532 82.3823 145.27 82.4339 145.048 82.5684L140.775 85.073C140.574 85.1665 140.417 85.3329 140.335 85.5383C140.253 85.7437 140.252 85.9727 140.333 86.1787L142.764 89.9346C142.893 90.1778 143.112 90.3607 143.375 90.4436C143.637 90.5266 143.921 90.5031 144.167 90.3781V90.3781Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M150.502 86.7679L154.554 84.4109C154.695 84.331 154.82 84.2239 154.92 84.0958C155.021 83.9677 155.095 83.8211 155.138 83.6643C155.182 83.5076 155.194 83.3437 155.175 83.1822C155.155 83.0207 155.104 82.8646 155.024 82.7229C154.994 82.6694 154.959 82.6182 154.922 82.5696L152.785 79.1805C152.616 78.9842 152.382 78.8542 152.126 78.8137C151.869 78.7733 151.607 78.8249 151.385 78.9594L147.112 81.464C146.912 81.5576 146.754 81.724 146.672 81.9294C146.59 82.1348 146.59 82.3637 146.67 82.5696L149.101 86.3262C149.243 86.5557 149.462 86.7265 149.719 86.8076C149.976 86.8887 150.254 86.8746 150.502 86.7679V86.7679Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M135.105 103.269L139.156 100.911C139.298 100.831 139.422 100.723 139.522 100.595C139.622 100.467 139.696 100.32 139.739 100.163C139.783 100.006 139.795 99.8421 139.774 99.6806C139.754 99.5192 139.703 99.3632 139.622 99.2217C139.593 99.1707 139.561 99.1218 139.525 99.0753L137.389 95.6869C137.219 95.4904 136.985 95.3603 136.729 95.3198C136.473 95.2793 136.21 95.331 135.988 95.4657L131.715 97.9703C131.515 98.0637 131.358 98.23 131.276 98.4353C131.194 98.6407 131.193 98.8695 131.274 99.0753L133.705 102.832C133.859 103.047 134.079 103.206 134.332 103.285C134.584 103.364 134.856 103.359 135.105 103.269V103.269Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M141.44 99.586L145.492 97.229C145.633 97.1491 145.758 97.0421 145.858 96.914C145.959 96.7859 146.033 96.6393 146.077 96.4826C146.12 96.3258 146.133 96.162 146.113 96.0005C146.094 95.8389 146.042 95.6828 145.963 95.541C145.932 95.4872 145.898 95.4358 145.86 95.3872L143.724 91.9987C143.554 91.8023 143.321 91.6724 143.064 91.6319C142.808 91.5914 142.546 91.6431 142.324 91.7776L138.051 94.2822C137.85 94.3756 137.693 94.5419 137.611 94.7472C137.529 94.9525 137.528 95.1814 137.609 95.3872L140.04 99.1438C140.178 99.3767 140.398 99.5505 140.656 99.6321C140.914 99.7136 141.193 99.6972 141.44 99.586V99.586Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M138.642 108.794L142.693 106.437C142.835 106.357 142.959 106.249 143.059 106.121C143.159 105.993 143.233 105.846 143.276 105.689C143.319 105.532 143.331 105.368 143.311 105.207C143.291 105.045 143.239 104.889 143.159 104.748C143.13 104.697 143.098 104.648 143.062 104.602L140.925 101.213C140.755 101.016 140.522 100.886 140.265 100.846C140.009 100.805 139.747 100.857 139.525 100.991L135.252 103.496C135.051 103.59 134.894 103.756 134.812 103.961C134.73 104.167 134.729 104.396 134.81 104.602L137.241 108.358C137.38 108.59 137.6 108.763 137.858 108.843C138.117 108.924 138.395 108.906 138.642 108.794V108.794Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M144.976 105.184L149.028 102.828C149.314 102.665 149.523 102.396 149.61 102.079C149.698 101.762 149.656 101.424 149.493 101.138C149.464 101.087 149.432 101.038 149.396 100.991L147.26 97.6029C147.09 97.4064 146.856 97.2763 146.6 97.2358C146.344 97.1954 146.081 97.2471 145.859 97.3818L141.587 99.8864C141.387 99.9797 141.229 100.146 141.147 100.351C141.065 100.557 141.064 100.785 141.145 100.991L143.576 104.748C143.639 104.868 143.725 104.975 143.829 105.062C143.932 105.15 144.052 105.216 144.182 105.256C144.311 105.297 144.447 105.312 144.582 105.3C144.717 105.289 144.849 105.25 144.969 105.188L144.976 105.184Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M147.702 95.9025L151.753 93.5461C151.895 93.4658 152.019 93.3583 152.119 93.2299C152.219 93.1015 152.293 92.9547 152.336 92.7977C152.379 92.6408 152.391 92.4769 152.371 92.3153C152.351 92.1538 152.299 91.9978 152.219 91.8563C152.19 91.8054 152.158 91.7567 152.122 91.7105L149.985 88.3214C149.816 88.1249 149.582 87.9948 149.326 87.9544C149.069 87.9139 148.807 87.9656 148.585 88.1003L144.312 90.6049C144.112 90.6984 143.955 90.8648 143.872 91.0702C143.79 91.2756 143.79 91.5046 143.871 91.7105L146.302 95.4671C146.428 95.7098 146.646 95.8925 146.907 95.9749C147.168 96.0574 147.451 96.0329 147.694 95.9068L147.702 95.9025Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M153.963 92.2929L158.015 89.9359C158.156 89.8556 158.281 89.7481 158.381 89.6198C158.481 89.4914 158.554 89.3445 158.597 89.1877C158.641 89.0308 158.653 88.867 158.632 88.7055C158.612 88.5441 158.561 88.3881 158.48 88.2467C158.452 88.1955 158.419 88.1465 158.383 88.1003L156.247 84.7118C156.077 84.5153 155.843 84.3853 155.587 84.3448C155.331 84.3043 155.068 84.356 154.846 84.4907L150.574 86.9947C150.374 87.0882 150.216 87.2546 150.134 87.46C150.052 87.6654 150.051 87.8943 150.132 88.1003L152.564 91.8569C152.706 92.0852 152.925 92.2548 153.182 92.3349C153.439 92.4149 153.716 92.4 153.963 92.2929V92.2929Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M151.312 101.502L155.363 99.1446C155.505 99.0643 155.629 98.957 155.729 98.8286C155.829 98.7002 155.903 98.5534 155.946 98.3965C155.989 98.2397 156.001 98.0758 155.981 97.9143C155.961 97.7528 155.909 97.5968 155.829 97.4554C155.8 97.4043 155.768 97.3554 155.732 97.309L153.595 93.9205C153.426 93.724 153.192 93.594 152.936 93.5535C152.679 93.513 152.417 93.5647 152.195 93.6994L147.922 96.204C147.722 96.2974 147.565 96.4637 147.482 96.669C147.4 96.8743 147.4 97.1032 147.481 97.309L149.912 101.066C150.051 101.297 150.27 101.47 150.529 101.551C150.787 101.631 151.066 101.614 151.312 101.502Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M157.647 97.8926L161.698 95.5363C161.984 95.3748 162.194 95.1061 162.283 94.7895C162.371 94.4728 162.33 94.1341 162.169 93.8477C162.138 93.7942 162.104 93.743 162.066 93.6944L159.93 90.306C159.76 90.1096 159.527 89.9796 159.27 89.9392C159.014 89.8987 158.752 89.9503 158.53 90.0849L154.257 92.5895C154.056 92.6828 153.899 92.8491 153.817 93.0545C153.735 93.2598 153.734 93.4886 153.815 93.6944L156.246 97.451C156.385 97.684 156.604 97.8578 156.862 97.9393C157.12 98.0207 157.4 98.0041 157.647 97.8926V97.8926Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M142.03 114.319L146.082 111.963C146.368 111.8 146.577 111.531 146.665 111.214C146.752 110.897 146.71 110.559 146.547 110.273C146.519 110.222 146.486 110.173 146.45 110.127L144.314 106.738C144.144 106.542 143.91 106.412 143.654 106.371C143.398 106.331 143.135 106.383 142.913 106.517L138.64 109.022C138.44 109.115 138.283 109.282 138.201 109.487C138.119 109.692 138.118 109.921 138.199 110.127L140.63 113.884C140.76 114.125 140.979 114.306 141.241 114.387C141.503 114.468 141.786 114.444 142.03 114.319Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M148.365 110.71L152.417 108.353C152.558 108.272 152.682 108.165 152.782 108.036C152.882 107.908 152.956 107.761 152.999 107.604C153.042 107.447 153.054 107.284 153.034 107.122C153.014 106.961 152.962 106.805 152.882 106.663C152.853 106.612 152.821 106.563 152.785 106.517L150.648 103.128C150.479 102.932 150.245 102.802 149.989 102.761C149.732 102.721 149.47 102.773 149.248 102.907L144.976 105.412C144.775 105.505 144.618 105.672 144.536 105.877C144.453 106.082 144.453 106.311 144.533 106.517L146.964 110.273C147.104 110.505 147.323 110.678 147.581 110.758C147.84 110.839 148.119 110.821 148.365 110.71V110.71Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M145.64 119.844L149.692 117.488C149.979 117.326 150.189 117.057 150.277 116.741C150.365 116.424 150.324 116.085 150.163 115.799C150.132 115.745 150.098 115.694 150.06 115.646L147.921 112.256C147.752 112.06 147.518 111.93 147.262 111.889C147.006 111.849 146.744 111.9 146.522 112.035L142.249 114.54C142.048 114.633 141.891 114.799 141.809 115.004C141.727 115.21 141.726 115.439 141.807 115.645L144.238 119.401C144.392 119.618 144.612 119.779 144.865 119.858C145.118 119.938 145.39 119.933 145.64 119.844V119.844Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M151.975 116.16L156.027 113.803C156.168 113.723 156.293 113.616 156.393 113.487C156.493 113.359 156.566 113.212 156.609 113.055C156.653 112.898 156.665 112.734 156.644 112.573C156.624 112.411 156.573 112.256 156.492 112.114C156.463 112.063 156.431 112.014 156.395 111.968L154.259 108.58C154.089 108.383 153.855 108.254 153.599 108.213C153.343 108.173 153.08 108.224 152.858 108.359L148.586 110.863C148.386 110.957 148.228 111.123 148.146 111.328C148.064 111.533 148.063 111.762 148.144 111.968L150.575 115.724C150.705 115.966 150.925 116.146 151.186 116.228C151.448 116.309 151.731 116.285 151.975 116.16V116.16Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M154.626 107.026L158.677 104.669C158.819 104.589 158.944 104.482 159.044 104.354C159.144 104.226 159.219 104.079 159.262 103.922C159.306 103.766 159.318 103.602 159.299 103.44C159.279 103.279 159.228 103.123 159.148 102.981C159.118 102.927 159.084 102.876 159.046 102.828L156.909 99.4387C156.74 99.2423 156.506 99.1123 156.249 99.0719C155.993 99.0314 155.731 99.083 155.509 99.2176L151.237 101.722C151.036 101.816 150.879 101.982 150.797 102.187C150.714 102.393 150.714 102.622 150.794 102.828L153.226 106.584C153.355 106.826 153.574 107.008 153.835 107.091C154.097 107.174 154.381 107.15 154.626 107.026V107.026Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M160.962 103.417L165.014 101.061C165.3 100.899 165.51 100.631 165.598 100.314C165.687 99.9974 165.645 99.6587 165.484 99.3724C165.454 99.3188 165.42 99.2675 165.382 99.2192L163.245 95.8307C163.076 95.6343 162.842 95.5044 162.586 95.4639C162.329 95.4234 162.067 95.475 161.845 95.6096L157.573 98.1136C157.372 98.2071 157.215 98.3735 157.133 98.5788C157.051 98.7842 157.05 99.0132 157.13 99.2192L159.562 102.976C159.7 103.209 159.919 103.383 160.178 103.464C160.436 103.545 160.715 103.529 160.962 103.417Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M158.236 112.478L162.288 110.12C162.429 110.039 162.553 109.932 162.653 109.804C162.754 109.675 162.827 109.529 162.871 109.372C162.914 109.215 162.926 109.051 162.906 108.889C162.886 108.728 162.834 108.572 162.753 108.43C162.725 108.379 162.692 108.33 162.656 108.284L160.52 104.896C160.35 104.699 160.117 104.569 159.86 104.529C159.604 104.488 159.341 104.54 159.12 104.675L154.847 107.179C154.646 107.272 154.489 107.439 154.407 107.644C154.325 107.849 154.324 108.078 154.405 108.284L156.836 112.041C156.966 112.282 157.185 112.463 157.447 112.545C157.709 112.627 157.992 112.603 158.236 112.478V112.478Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M164.572 108.868L168.623 106.511C168.91 106.35 169.12 106.081 169.208 105.764C169.296 105.448 169.255 105.109 169.094 104.823C169.064 104.769 169.029 104.718 168.991 104.669L166.855 101.281C166.685 101.085 166.452 100.955 166.195 100.914C165.939 100.874 165.677 100.925 165.455 101.06L161.182 103.564C160.982 103.658 160.825 103.824 160.742 104.029C160.66 104.235 160.659 104.464 160.74 104.669L163.171 108.426C163.313 108.655 163.532 108.826 163.789 108.907C164.046 108.989 164.324 108.974 164.572 108.868V108.868Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M149.324 125.295L153.375 122.939C153.516 122.859 153.641 122.751 153.741 122.623C153.841 122.494 153.914 122.348 153.958 122.191C154.001 122.034 154.013 121.87 153.993 121.708C153.973 121.547 153.921 121.391 153.841 121.249C153.812 121.198 153.779 121.15 153.743 121.103L151.605 117.707C151.435 117.511 151.202 117.381 150.945 117.341C150.689 117.3 150.427 117.352 150.205 117.486L145.931 119.991C145.731 120.084 145.574 120.251 145.492 120.456C145.41 120.661 145.409 120.89 145.49 121.096L147.921 124.852C148.059 125.086 148.279 125.261 148.538 125.343C148.797 125.424 149.077 125.407 149.324 125.295V125.295Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M155.585 121.686L159.637 119.329C159.778 119.249 159.903 119.141 160.003 119.013C160.103 118.884 160.176 118.738 160.219 118.581C160.263 118.424 160.275 118.26 160.254 118.099C160.234 117.937 160.183 117.781 160.102 117.64C160.074 117.588 160.041 117.54 160.005 117.493L157.869 114.105C157.699 113.908 157.465 113.778 157.209 113.738C156.953 113.697 156.69 113.749 156.468 113.884L152.196 116.388C151.996 116.482 151.838 116.648 151.756 116.853C151.674 117.059 151.673 117.287 151.754 117.493L154.185 121.25C154.328 121.478 154.547 121.648 154.804 121.728C155.061 121.808 155.338 121.793 155.585 121.686V121.686Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M161.847 118.002L165.898 115.646C166.039 115.565 166.164 115.458 166.264 115.329C166.364 115.201 166.437 115.054 166.481 114.897C166.524 114.74 166.536 114.576 166.516 114.415C166.496 114.253 166.444 114.097 166.364 113.956C166.335 113.905 166.302 113.856 166.266 113.809L164.128 110.413C163.958 110.217 163.725 110.087 163.468 110.047C163.212 110.006 162.95 110.058 162.728 110.192L158.455 112.697C158.255 112.791 158.097 112.957 158.015 113.162C157.933 113.368 157.932 113.597 158.013 113.803L160.444 117.56C160.586 117.79 160.806 117.961 161.063 118.042C161.321 118.124 161.599 118.109 161.847 118.002Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M168.181 114.392L172.233 112.036C172.374 111.956 172.498 111.848 172.598 111.72C172.699 111.592 172.772 111.445 172.816 111.288C172.859 111.131 172.871 110.967 172.851 110.805C172.831 110.644 172.779 110.488 172.698 110.346C172.669 110.295 172.637 110.247 172.601 110.2L170.464 106.811C170.295 106.615 170.061 106.485 169.805 106.445C169.549 106.404 169.286 106.456 169.065 106.59L164.792 109.095C164.591 109.188 164.434 109.354 164.352 109.56C164.27 109.765 164.269 109.994 164.35 110.2L166.781 113.956C166.923 114.185 167.143 114.355 167.4 114.435C167.657 114.515 167.934 114.5 168.181 114.392Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M146.67 73.8763L170.833 112.698L146.67 73.8763Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M146.67 73.8763L170.833 112.698L146.67 73.8763Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M145.123 74.8341L169.286 113.655L145.123 74.8341Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M145.123 74.8341L169.286 113.655L145.123 74.8341Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M140.482 77.6352L164.645 116.456L140.482 77.6352Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M140.482 77.6352L164.645 116.456L140.482 77.6352Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M138.935 78.592L163.098 117.412L138.935 78.592Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M138.935 78.592L163.098 117.412L138.935 78.592Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M134.294 81.2429L158.457 120.064L134.294 81.2429Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M134.294 81.2429L158.457 120.064L134.294 81.2429Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M132.674 82.201L156.836 121.023L132.674 82.201Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M132.674 82.201L156.836 121.023L132.674 82.201Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M128.033 84.8527L152.195 123.674L128.033 84.8527Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M128.033 84.8527L152.195 123.674L128.033 84.8527Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M126.486 85.8119L150.649 124.632L126.486 85.8119Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M126.486 85.8119L150.649 124.632L126.486 85.8119Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M148.66 72.478L148.807 72.5515L123.539 87.28L123.392 87.2065L148.66 72.478Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M148.807 72.5513L148.88 72.6976L123.686 87.2842V87.2101L148.807 72.5513Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M123.539 87.2848L123.392 87.2113L147.923 126.18L148.218 126.327L123.539 87.2848Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M123.539 87.2848L123.686 87.2113L148.291 126.254L148.217 126.327L123.539 87.2848Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M148.659 72.7712L148.585 72.8447L173.337 111.519L173.483 111.593L148.659 72.7712Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M148.659 72.6248L148.806 72.5513L173.706 111.449L173.483 111.596L148.659 72.6248Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M173.337 111.372H173.483L148.291 126.174L148.217 126.027L173.337 111.372Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M173.484 111.372V111.593L148.291 126.253V126.174L173.484 111.372Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M96.725 46.9156L95.8417 48.0941L146.155 129.272L147.039 128.02L96.725 46.9156Z",
    fill: "#3D3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M147.039 128.02L146.156 129.272L173.411 113.361L174.663 112.034L147.039 128.02Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M123.613 33.0664L98.5671 47.7265L123.171 86.5473L148.29 71.8144L123.613 33.0664Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M102.988 52.7351L107.04 50.3788C107.325 50.2164 107.535 49.9471 107.622 49.6302C107.709 49.3133 107.667 48.9747 107.505 48.6889C107.476 48.6377 107.444 48.5888 107.408 48.5425L105.271 45.1541C105.102 44.9576 104.868 44.8275 104.612 44.787C104.355 44.7464 104.093 44.7979 103.871 44.9323L99.5987 47.4369C99.3982 47.5304 99.2409 47.6968 99.1588 47.9022C99.0766 48.1076 99.0758 48.3365 99.1564 48.5425L101.588 52.2991C101.739 52.5178 101.959 52.6797 102.213 52.7587C102.466 52.8377 102.739 52.8294 102.988 52.7351V52.7351Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M109.25 49.0515L113.301 46.6958C113.588 46.5341 113.798 46.2653 113.886 45.9485C113.974 45.6318 113.933 45.2929 113.772 45.0065C113.742 44.9529 113.707 44.9017 113.669 44.8533L111.533 41.4648C111.363 41.2685 111.13 41.1387 110.873 41.0983C110.617 41.058 110.355 41.1097 110.133 41.2444L105.86 43.7483C105.66 43.8417 105.503 44.0079 105.42 44.2132C105.338 44.4185 105.337 44.6474 105.418 44.8533L107.849 48.6099C107.991 48.8393 108.21 49.0102 108.467 49.0913C108.724 49.1724 109.002 49.1583 109.25 49.0515Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M106.597 58.1865L110.649 55.8295C110.79 55.7496 110.915 55.6425 111.015 55.5144C111.116 55.3863 111.19 55.2397 111.233 55.083C111.277 54.9262 111.289 54.7624 111.27 54.6009C111.25 54.4393 111.199 54.2833 111.119 54.1416C111.089 54.0877 111.055 54.0363 111.017 53.9877L108.878 50.5245C108.709 50.328 108.475 50.198 108.219 50.1575C107.962 50.117 107.7 50.1687 107.478 50.3034L103.205 52.808C103.005 52.9014 102.847 53.0678 102.765 53.2733C102.683 53.4787 102.683 53.7077 102.764 53.9136L105.195 57.6702C105.313 57.9234 105.527 58.1197 105.79 58.2163C106.052 58.313 106.342 58.3023 106.597 58.1865V58.1865Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M112.932 54.5768L116.984 52.2198C117.125 52.1395 117.249 52.0322 117.35 51.9038C117.45 51.7755 117.523 51.6286 117.567 51.4718C117.61 51.3149 117.622 51.151 117.602 50.9895C117.582 50.828 117.53 50.6721 117.449 50.5306C117.421 50.4797 117.388 50.431 117.352 50.3848L115.216 46.9951C115.046 46.7987 114.812 46.6687 114.556 46.6283C114.3 46.588 114.037 46.6398 113.816 46.7746L109.543 49.2792C109.342 49.3727 109.185 49.5391 109.103 49.7445C109.021 49.95 109.02 50.1789 109.101 50.3848L111.532 54.1401C111.683 54.359 111.903 54.521 112.157 54.6002C112.411 54.6793 112.684 54.6711 112.932 54.5768V54.5768Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M115.584 45.4419L119.636 43.0849C119.778 43.0046 119.902 42.8971 120.002 42.7687C120.102 42.6404 120.175 42.4935 120.219 42.3367C120.262 42.1798 120.274 42.016 120.254 41.8545C120.233 41.693 120.182 41.5371 120.101 41.3957C120.073 41.3445 120.04 41.2956 120.004 41.2493L117.868 37.8608C117.698 37.6644 117.464 37.5344 117.208 37.4941C116.952 37.4537 116.689 37.5055 116.467 37.6403L112.195 40.1443C111.995 40.2376 111.837 40.4039 111.755 40.6092C111.673 40.8145 111.672 41.0434 111.753 41.2493L114.185 45.0059C114.335 45.2247 114.555 45.3866 114.809 45.4657C115.063 45.5447 115.336 45.5363 115.584 45.4419Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M121.846 41.7594L125.898 39.4025C126.039 39.3221 126.163 39.2147 126.263 39.0863C126.363 38.9579 126.437 38.8111 126.48 38.6542C126.523 38.4974 126.535 38.3335 126.515 38.172C126.495 38.0106 126.443 37.8547 126.363 37.7132C126.334 37.662 126.302 37.6131 126.266 37.5668L124.129 34.1784C123.96 33.9817 123.726 33.8514 123.47 33.8108C123.213 33.7702 122.951 33.8219 122.729 33.9566L118.457 36.4612C118.256 36.5546 118.099 36.721 118.017 36.9264C117.934 37.1318 117.934 37.3609 118.014 37.5668L120.446 41.3234C120.588 41.5517 120.808 41.7213 121.065 41.8014C121.322 41.8814 121.599 41.8665 121.846 41.7594V41.7594Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M119.194 50.8934L123.245 48.5358C123.531 48.3733 123.741 48.1041 123.828 47.7872C123.915 47.4703 123.873 47.1317 123.711 46.8459C123.682 46.7948 123.649 46.7459 123.614 46.6995L121.477 43.3117C121.308 43.1151 121.074 42.985 120.818 42.9444C120.561 42.9038 120.299 42.9553 120.077 43.09L115.805 45.5945C115.604 45.6879 115.447 45.8541 115.365 46.0594C115.282 46.2648 115.282 46.4937 115.362 46.6995L117.794 50.4561C117.945 50.6751 118.165 50.8372 118.418 50.9165C118.672 50.9958 118.945 50.9877 119.194 50.8934V50.8934Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M125.529 47.2102L129.58 44.8532C129.722 44.773 129.846 44.6656 129.946 44.5372C130.046 44.4089 130.12 44.2621 130.163 44.1052C130.207 43.9483 130.219 43.7844 130.198 43.6229C130.178 43.4614 130.127 43.3055 130.046 43.164C130.017 43.1129 129.985 43.064 129.949 43.0176L127.813 39.6292C127.643 39.4325 127.409 39.3024 127.153 39.2619C126.897 39.2214 126.634 39.2732 126.412 39.4081L122.139 41.9126C121.939 42.006 121.782 42.1723 121.7 42.3776C121.618 42.583 121.617 42.8118 121.698 43.0176L124.129 46.7742C124.255 47.0172 124.473 47.2 124.734 47.2825C124.995 47.3649 125.279 47.3403 125.522 47.2139L125.529 47.2102Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M110.133 63.7121L114.185 61.3551C114.471 61.1927 114.68 60.9234 114.768 60.6065C114.855 60.2896 114.813 59.951 114.65 59.6652C114.622 59.6143 114.589 59.5656 114.553 59.5195L112.417 56.1304C112.247 55.9339 112.013 55.8038 111.757 55.7633C111.501 55.7228 111.238 55.7745 111.016 55.9092L106.744 58.4138C106.544 58.5074 106.386 58.6737 106.304 58.8791C106.222 59.0845 106.221 59.3135 106.302 59.5194L108.733 63.276C108.872 63.5078 109.092 63.6803 109.35 63.7607C109.608 63.8412 109.887 63.8238 110.133 63.7121Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M116.394 60.0276L120.445 57.6719C120.732 57.5104 120.942 57.2417 121.03 56.9251C121.119 56.6084 121.078 56.2697 120.916 55.9833C120.886 55.9296 120.852 55.8782 120.814 55.8294L118.678 52.4416C118.508 52.2451 118.274 52.115 118.018 52.0745C117.762 52.034 117.499 52.0858 117.277 52.2205L113.004 54.7251C112.804 54.8183 112.647 54.9845 112.565 55.1897C112.483 55.3949 112.482 55.6237 112.563 55.8294L114.994 59.586C115.123 59.8284 115.342 60.0105 115.604 60.0931C115.866 60.1757 116.149 60.1522 116.394 60.0276V60.0276Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M113.595 69.3097L117.647 66.9534C117.933 66.791 118.142 66.5217 118.23 66.2048C118.317 65.8879 118.275 65.5493 118.112 65.2635C118.084 65.2124 118.051 65.1635 118.015 65.1172L115.879 61.7287C115.709 61.5322 115.475 61.4021 115.219 61.3616C114.963 61.3212 114.7 61.3729 114.478 61.5076L110.206 64.0122C110.006 64.1055 109.848 64.2718 109.766 64.4771C109.684 64.6824 109.683 64.9113 109.764 65.1171L112.195 68.8737C112.349 69.0888 112.569 69.2477 112.822 69.3264C113.075 69.4051 113.346 69.3993 113.595 69.3097V69.3097Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M119.931 65.7003L123.983 63.3427C124.269 63.1802 124.478 62.911 124.566 62.5941C124.653 62.2772 124.611 61.9386 124.448 61.6528C124.42 61.6019 124.387 61.5532 124.351 61.507L122.215 58.1186C122.045 57.9221 121.811 57.792 121.555 57.7515C121.299 57.711 121.036 57.7628 120.814 57.8975L116.542 60.4021C116.342 60.4954 116.184 60.6617 116.102 60.867C116.02 61.0723 116.019 61.3011 116.1 61.507L118.532 65.2636C118.674 65.492 118.893 65.6618 119.15 65.7419C119.407 65.822 119.684 65.8073 119.931 65.7003V65.7003Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M122.656 56.4181L126.707 54.0611C126.849 53.9812 126.974 53.8741 127.074 53.7461C127.174 53.618 127.249 53.4714 127.292 53.3146C127.336 53.1579 127.348 52.9941 127.329 52.8325C127.309 52.671 127.258 52.5149 127.178 52.3731C127.148 52.3195 127.114 52.2683 127.076 52.2199L124.94 48.8308C124.77 48.6344 124.536 48.5044 124.28 48.4639C124.024 48.4235 123.761 48.4751 123.539 48.6096L119.266 51.1142C119.066 51.2078 118.909 51.3742 118.827 51.5796C118.745 51.785 118.744 52.014 118.825 52.2198L121.256 55.9764C121.397 56.2058 121.617 56.3766 121.874 56.4576C122.131 56.5387 122.408 56.5247 122.656 56.4181V56.4181Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M128.991 52.7351L133.042 50.3781C133.183 50.2978 133.308 50.1905 133.408 50.0621C133.508 49.9337 133.582 49.7869 133.625 49.63C133.668 49.4732 133.68 49.3093 133.66 49.1478C133.64 48.9863 133.588 48.8303 133.508 48.6889C133.479 48.6378 133.447 48.5889 133.411 48.5425L131.274 45.154C131.105 44.9573 130.871 44.8271 130.615 44.7864C130.358 44.7458 130.096 44.7975 129.874 44.9323L125.601 47.4369C125.401 47.5305 125.243 47.6969 125.161 47.9023C125.079 48.1077 125.079 48.3366 125.159 48.5425L127.59 52.2991C127.73 52.5309 127.949 52.7034 128.208 52.7838C128.466 52.8642 128.744 52.8469 128.991 52.7351V52.7351Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M126.339 61.9436L130.391 59.5867C130.532 59.5063 130.656 59.3989 130.756 59.2705C130.856 59.1421 130.93 58.9953 130.973 58.8384C131.016 58.6815 131.028 58.5177 131.008 58.3562C130.988 58.1948 130.936 58.0389 130.856 57.8974C130.827 57.8462 130.795 57.7973 130.759 57.751L128.622 54.3619C128.453 54.1657 128.219 54.0358 127.963 53.9953C127.706 53.9549 127.444 54.0064 127.222 54.1408L122.95 56.6454C122.749 56.7389 122.592 56.9053 122.51 57.1107C122.428 57.3161 122.427 57.545 122.508 57.751L124.939 61.5076C125.074 61.7433 125.294 61.9192 125.553 62C125.813 62.0809 126.093 62.0607 126.339 61.9436Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M132.6 58.333L136.651 55.9772C136.938 55.8157 137.148 55.5471 137.237 55.2304C137.325 54.9138 137.284 54.575 137.122 54.2886C137.092 54.2349 137.058 54.1835 137.02 54.1348L134.884 50.7469C134.714 50.5504 134.48 50.4204 134.224 50.3799C133.968 50.3394 133.705 50.3911 133.483 50.5258L129.211 53.0298C129.01 53.1232 128.853 53.2895 128.771 53.4948C128.689 53.7001 128.688 53.929 128.769 54.1348L131.2 57.8913C131.342 58.1208 131.561 58.2917 131.818 58.3728C132.075 58.4538 132.353 58.4397 132.6 58.333V58.333Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M117.058 74.8347L121.109 72.4778C121.251 72.3979 121.375 72.2909 121.476 72.1628C121.576 72.0347 121.65 71.8881 121.694 71.7313C121.738 71.5746 121.75 71.4108 121.731 71.2492C121.711 71.0876 121.66 70.9315 121.58 70.7898C121.55 70.7363 121.516 70.6851 121.478 70.6366L119.341 67.2474C119.172 67.0513 118.938 66.9215 118.682 66.8811C118.425 66.8406 118.163 66.8921 117.941 67.0263L113.668 69.5309C113.468 69.6245 113.311 69.7909 113.228 69.9963C113.146 70.2017 113.146 70.4306 113.227 70.6365L115.658 74.3931C115.796 74.6261 116.015 74.8 116.273 74.8814C116.532 74.9629 116.811 74.9463 117.058 74.8347V74.8347Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M123.319 71.1517L127.371 68.7935C127.512 68.7132 127.636 68.6057 127.736 68.4774C127.836 68.349 127.91 68.2022 127.953 68.0453C127.996 67.8884 128.008 67.7246 127.988 67.5631C127.968 67.4017 127.916 67.2457 127.836 67.1043C127.807 67.0531 127.775 67.0041 127.739 66.9579L125.602 63.5695C125.433 63.3729 125.199 63.2429 124.943 63.2024C124.686 63.1619 124.424 63.2136 124.202 63.3483L119.93 65.8529C119.729 65.9463 119.572 66.1125 119.49 66.3178C119.407 66.5231 119.407 66.752 119.487 66.9579L121.918 70.7145C122.048 70.956 122.268 71.137 122.529 71.2187C122.791 71.3005 123.074 71.2764 123.319 71.1517V71.1517Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M120.667 80.2864L124.719 77.9281C125.005 77.7657 125.214 77.4965 125.301 77.1796C125.389 76.8627 125.347 76.5241 125.184 76.2383C125.155 76.1872 125.123 76.1382 125.087 76.0919L122.951 72.7041C122.781 72.5075 122.548 72.3774 122.291 72.3368C122.035 72.2962 121.773 72.3477 121.551 72.4823L117.278 74.9869C117.078 75.0802 116.92 75.2465 116.838 75.4518C116.756 75.6571 116.755 75.886 116.836 76.0919L119.267 79.8485C119.406 80.0807 119.626 80.2538 119.884 80.3346C120.142 80.4153 120.421 80.3982 120.667 80.2864Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M127.003 76.6766L131.054 74.3197C131.195 74.2393 131.32 74.1319 131.42 74.0035C131.52 73.8751 131.594 73.7282 131.637 73.5713C131.68 73.4143 131.692 73.2504 131.672 73.0889C131.652 72.9273 131.6 72.7713 131.52 72.6298C131.491 72.579 131.458 72.5303 131.423 72.484L129.286 69.095C129.117 68.8985 128.883 68.7684 128.627 68.7279C128.37 68.6874 128.108 68.7391 127.886 68.8738L123.613 71.3784C123.413 71.472 123.255 71.6384 123.173 71.8438C123.091 72.0492 123.091 72.2782 123.171 72.484L125.602 76.2406C125.754 76.4593 125.974 76.6211 126.227 76.7001C126.481 76.7792 126.754 76.7709 127.003 76.6766Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M129.654 67.5415L133.706 65.1851C133.992 65.0236 134.202 64.755 134.291 64.4383C134.379 64.1217 134.338 63.7829 134.176 63.4965C134.146 63.443 134.112 63.3918 134.074 63.3433L131.938 59.9548C131.768 59.7583 131.535 59.6283 131.278 59.5878C131.022 59.5473 130.759 59.599 130.538 59.7337L126.265 62.2377C126.064 62.3313 125.907 62.4977 125.825 62.7031C125.743 62.9085 125.742 63.1374 125.823 63.3433L128.254 67.0999C128.404 67.3199 128.624 67.483 128.878 67.5631C129.132 67.6432 129.405 67.6356 129.654 67.5415Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M135.915 63.8578L139.967 61.5008C140.108 61.4205 140.232 61.3131 140.332 61.1847C140.432 61.0563 140.506 60.9095 140.549 60.7526C140.592 60.5957 140.604 60.4319 140.584 60.2704C140.564 60.109 140.512 59.9531 140.432 59.8116C140.403 59.7607 140.371 59.712 140.335 59.6658L138.198 56.2767C138.029 56.0802 137.795 55.9502 137.539 55.9097C137.282 55.8692 137.02 55.9209 136.798 56.0556L132.526 58.5602C132.325 58.6537 132.168 58.8201 132.086 59.0255C132.004 59.2309 132.003 59.4598 132.083 59.6658L134.515 63.4224C134.657 63.6509 134.877 63.8206 135.134 63.9005C135.391 63.9805 135.668 63.9653 135.915 63.8578V63.8578Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M133.263 72.9928L137.315 70.6358C137.601 70.4735 137.81 70.2044 137.898 69.8877C137.985 69.5709 137.943 69.2324 137.781 68.9466C137.752 68.8957 137.719 68.847 137.683 68.8008L135.547 65.4111C135.377 65.2147 135.144 65.0848 134.887 65.0444C134.631 65.0041 134.369 65.0559 134.147 65.1906L129.874 67.6952C129.674 67.7887 129.516 67.9551 129.434 68.1605C129.352 68.3659 129.351 68.5949 129.432 68.8008L131.864 72.5562C132.014 72.7751 132.234 72.9371 132.488 73.0163C132.742 73.0954 133.015 73.0872 133.263 72.9928Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M139.599 69.3092L143.65 66.9529C143.791 66.8726 143.916 66.7652 144.016 66.6368C144.116 66.5085 144.189 66.3617 144.233 66.2048C144.276 66.0479 144.288 65.8841 144.268 65.7226C144.248 65.5611 144.196 65.4051 144.116 65.2636C144.087 65.2125 144.054 65.1633 144.018 65.1166L141.882 61.7288C141.712 61.5325 141.479 61.4027 141.222 61.3622C140.966 61.3217 140.704 61.3733 140.482 61.5077L136.209 64.0123C136.008 64.1055 135.851 64.2717 135.769 64.4769C135.687 64.6821 135.686 64.9109 135.767 65.1166L138.198 68.8732C138.325 69.1163 138.542 69.2992 138.804 69.3818C139.065 69.4643 139.348 69.4398 139.591 69.3136L139.599 69.3092Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M124.278 85.8112L128.329 83.4542C128.47 83.3739 128.595 83.2665 128.695 83.1382C128.795 83.0099 128.868 82.8631 128.912 82.7063C128.955 82.5495 128.967 82.3857 128.947 82.2243C128.926 82.0628 128.875 81.907 128.794 81.7656C128.766 81.7142 128.733 81.665 128.697 81.6186L126.559 78.2226C126.389 78.0263 126.155 77.8963 125.899 77.8559C125.643 77.8154 125.38 77.867 125.159 78.0015L120.886 80.5061C120.686 80.5995 120.528 80.7658 120.446 80.9713C120.364 81.1767 120.363 81.4058 120.444 81.6117L122.875 85.3683C123.029 85.5851 123.249 85.7457 123.502 85.8256C123.755 85.9056 124.028 85.9005 124.278 85.8112V85.8112Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M130.613 82.1281L134.664 79.7711C134.806 79.6909 134.93 79.5835 135.03 79.4551C135.13 79.3268 135.204 79.18 135.247 79.0231C135.291 78.8662 135.302 78.7023 135.282 78.5408C135.262 78.3793 135.211 78.2234 135.13 78.0819C135.101 78.0308 135.069 77.9819 135.033 77.9355L132.896 74.5464C132.727 74.3499 132.493 74.2199 132.237 74.1794C131.981 74.1389 131.718 74.1906 131.496 74.3253L127.223 76.8299C127.023 76.9235 126.866 77.0899 126.784 77.2953C126.702 77.5007 126.701 77.7296 126.782 77.9355L129.213 81.6921C129.339 81.935 129.557 82.1177 129.818 82.2002C130.079 82.2826 130.363 82.2581 130.606 82.1319L130.613 82.1281Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M136.873 78.4443L140.925 76.0879C141.211 75.9255 141.42 75.6562 141.508 75.3393C141.595 75.0224 141.553 74.6838 141.39 74.398C141.362 74.347 141.329 74.2983 141.293 74.2523L139.157 70.8632C138.987 70.6667 138.753 70.5366 138.497 70.4962C138.241 70.4557 137.978 70.5074 137.756 70.6421L133.484 73.1467C133.284 73.2402 133.126 73.4065 133.044 73.6119C132.962 73.8173 132.961 74.0463 133.042 74.2523L135.474 78.0089C135.6 78.2517 135.818 78.4344 136.079 78.5169C136.34 78.5993 136.623 78.5748 136.866 78.4486L136.873 78.4443Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M143.209 74.8347L147.26 72.4778C147.402 72.3979 147.526 72.2909 147.627 72.1628C147.727 72.0347 147.801 71.8881 147.845 71.7313C147.889 71.5746 147.901 71.4108 147.881 71.2492C147.862 71.0876 147.811 70.9315 147.731 70.7898C147.7 70.7363 147.666 70.6851 147.629 70.6366L145.492 67.2474C145.322 67.0513 145.089 66.9215 144.832 66.8811C144.576 66.8406 144.314 66.8921 144.092 67.0263L139.819 69.5309C139.618 69.6245 139.461 69.7909 139.379 69.9963C139.297 70.2017 139.297 70.4306 139.377 70.6365L141.808 74.3931C141.947 74.6261 142.166 74.8 142.424 74.8814C142.682 74.9629 142.962 74.9463 143.209 74.8347Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M121.698 34.392L145.86 73.2128L121.698 34.392Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M121.698 34.392L145.86 73.2128L121.698 34.392Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M120.15 35.3501L144.313 74.1716L120.15 35.3501Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M120.15 35.3501L144.313 74.1716L120.15 35.3501Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M115.509 38.0751L139.672 76.8966L115.509 38.0751Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M115.509 38.0751L139.672 76.8966L115.509 38.0751Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M113.889 39.0343L138.052 77.8552L113.889 39.0343Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M113.889 39.0343L138.052 77.8552L113.889 39.0343Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M109.248 41.6857L133.411 80.506L109.248 41.6857Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M109.248 41.6857L133.411 80.506L109.248 41.6857Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M107.701 42.6439L131.864 81.4641L107.701 42.6439Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M107.701 42.6439L131.864 81.4641L107.701 42.6439Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M103.061 45.2961L127.224 84.1163L103.061 45.2961Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M103.061 45.2961L127.224 84.1163L103.061 45.2961Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M101.44 46.2521L125.602 85.0729L101.44 46.2521Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M101.44 46.2521L125.602 85.0729L101.44 46.2521Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M123.687 32.9189L123.834 32.9924L98.5661 47.721L98.4191 47.6469L123.687 32.9189Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M123.834 32.9926V33.1396L98.7143 47.7255V47.652L123.834 32.9926Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M98.5669 47.7253L98.4193 47.6518L122.95 86.6209L123.172 86.8426L98.5669 47.7253Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M98.5665 47.7252L98.64 47.6523L123.318 86.7685L123.171 86.8414L98.5665 47.7252Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M123.686 33.2136L123.613 33.2877L148.364 71.9616L148.511 72.0345L123.686 33.2136Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M123.613 33.0661L123.834 32.9926L148.734 71.89L148.512 72.037L123.613 33.0661Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M148.291 71.8145L148.438 71.8879L123.245 86.6165V86.543L148.291 71.8145Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M148.438 71.8881L148.511 72.0344L123.318 86.7686L123.245 86.621L148.438 71.8881Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M95.8411 47.4307L69.0269 62.9005L119.34 144.079L147.039 128.095L95.8411 47.4307Z",
    fill: "#D5C5E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M120.961 88.6097L95.842 103.269L120.52 142.167L145.639 127.434L120.961 88.6097Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M100.336 108.278L104.387 105.921C104.529 105.84 104.653 105.733 104.753 105.605C104.853 105.477 104.927 105.33 104.97 105.173C105.013 105.016 105.025 104.852 105.005 104.691C104.985 104.529 104.933 104.374 104.853 104.232C104.824 104.181 104.792 104.132 104.756 104.085L102.619 100.697C102.45 100.501 102.216 100.37 101.96 100.33C101.703 100.289 101.441 100.341 101.219 100.476L96.9462 102.979C96.7458 103.073 96.5886 103.239 96.5066 103.445C96.4246 103.65 96.4238 103.879 96.5046 104.085L98.9357 107.842C99.0748 108.074 99.2944 108.246 99.5527 108.327C99.8109 108.407 100.09 108.39 100.336 108.278V108.278Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M106.597 104.668L110.648 102.311C110.79 102.231 110.915 102.124 111.015 101.996C111.116 101.868 111.19 101.721 111.233 101.564C111.277 101.408 111.289 101.244 111.27 101.082C111.25 100.92 111.199 100.764 111.119 100.623C111.089 100.569 111.055 100.518 111.017 100.469L108.878 97.0797C108.709 96.8833 108.475 96.7534 108.219 96.7129C107.962 96.6724 107.7 96.724 107.478 96.8586L103.205 99.3632C103.005 99.4565 102.847 99.6227 102.765 99.8281C102.683 100.033 102.683 100.262 102.763 100.468L105.195 104.225C105.336 104.455 105.555 104.627 105.813 104.708C106.071 104.789 106.349 104.775 106.597 104.668V104.668Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M103.945 113.729L107.996 111.372C108.138 111.292 108.262 111.185 108.363 111.057C108.463 110.929 108.537 110.782 108.581 110.626C108.625 110.469 108.637 110.305 108.618 110.144C108.598 109.982 108.547 109.826 108.467 109.684C108.437 109.631 108.402 109.579 108.365 109.531L106.228 106.142C106.059 105.945 105.825 105.815 105.569 105.775C105.312 105.734 105.05 105.786 104.828 105.921L100.555 108.425C100.355 108.519 100.197 108.685 100.115 108.891C100.033 109.096 100.033 109.325 100.113 109.531L102.545 113.287C102.67 113.531 102.887 113.715 103.148 113.799C103.408 113.882 103.692 113.859 103.935 113.734L103.945 113.729Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M110.207 110.12L114.258 107.763C114.544 107.601 114.754 107.332 114.841 107.015C114.928 106.698 114.886 106.359 114.724 106.073C114.695 106.022 114.663 105.974 114.626 105.928L112.49 102.539C112.32 102.342 112.087 102.212 111.83 102.172C111.574 102.131 111.312 102.183 111.09 102.317L106.817 104.822C106.617 104.916 106.46 105.082 106.377 105.287C106.295 105.493 106.294 105.722 106.375 105.928L108.807 109.684C108.949 109.913 109.169 110.082 109.426 110.162C109.683 110.242 109.96 110.227 110.207 110.12Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M112.859 100.984L116.911 98.628C117.197 98.4656 117.406 98.1963 117.493 97.8794C117.581 97.5625 117.538 97.2239 117.376 96.9381C117.347 96.887 117.315 96.8381 117.279 96.7918L115.143 93.4033C114.973 93.2071 114.739 93.0772 114.483 93.0367C114.227 92.9962 113.964 93.0478 113.742 93.1822L109.47 95.6868C109.269 95.7801 109.112 95.9464 109.03 96.1517C108.948 96.357 108.947 96.5859 109.028 96.7917L111.459 100.548C111.601 100.777 111.821 100.947 112.078 101.027C112.335 101.107 112.612 101.092 112.859 100.984V100.984Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M119.194 97.3761L123.245 95.0192C123.531 94.8567 123.741 94.5875 123.828 94.2706C123.915 93.9537 123.873 93.6151 123.711 93.3293C123.682 93.2783 123.65 93.2296 123.614 93.1835L121.477 89.7944C121.307 89.5979 121.074 89.4679 120.817 89.4274C120.561 89.3869 120.299 89.4386 120.077 89.5733L115.804 92.0779C115.604 92.1714 115.447 92.3378 115.364 92.5432C115.282 92.7486 115.282 92.9775 115.362 93.1835L117.794 96.9401C117.945 97.1588 118.165 97.3206 118.418 97.3997C118.672 97.4787 118.945 97.4704 119.194 97.3761V97.3761Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M116.469 106.436L120.521 104.08C120.806 103.918 121.016 103.648 121.103 103.332C121.19 103.015 121.148 102.676 120.986 102.39C120.957 102.339 120.925 102.29 120.889 102.244L118.752 98.8554C118.583 98.6589 118.349 98.5288 118.093 98.4883C117.836 98.4479 117.574 98.4996 117.352 98.6343L113.08 101.139C112.879 101.232 112.722 101.398 112.64 101.604C112.557 101.809 112.557 102.038 112.637 102.244L115.068 106C115.211 106.229 115.43 106.399 115.688 106.479C115.945 106.559 116.222 106.544 116.469 106.436V106.436Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M122.804 102.827L126.855 100.469C126.997 100.389 127.121 100.282 127.221 100.153C127.321 100.025 127.394 99.8782 127.438 99.7213C127.481 99.5645 127.493 99.4007 127.473 99.2393C127.453 99.0779 127.401 98.922 127.32 98.7806C127.292 98.7292 127.259 98.6801 127.223 98.6336L125.085 95.2383C124.915 95.0418 124.682 94.9118 124.425 94.8712C124.169 94.8306 123.907 94.8821 123.685 95.0166L119.412 97.5211C119.212 97.6147 119.054 97.7811 118.972 97.9867C118.89 98.1922 118.889 98.4213 118.97 98.6274L121.401 102.383C121.543 102.613 121.762 102.785 122.02 102.866C122.277 102.948 122.556 102.934 122.804 102.827V102.827Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M107.408 119.255L111.459 116.898C111.601 116.818 111.725 116.711 111.826 116.583C111.926 116.455 112 116.308 112.044 116.151C112.088 115.994 112.1 115.831 112.08 115.669C112.061 115.508 112.01 115.351 111.93 115.21C111.9 115.156 111.865 115.105 111.828 115.056L109.691 111.667C109.521 111.471 109.288 111.341 109.031 111.3C108.775 111.26 108.513 111.312 108.291 111.446L104.018 113.951C103.817 114.044 103.66 114.211 103.578 114.416C103.496 114.622 103.495 114.851 103.576 115.056L106.007 118.813C106.137 119.055 106.356 119.237 106.617 119.32C106.879 119.402 107.163 119.379 107.408 119.255V119.255Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M113.743 115.644L117.794 113.288C118.081 113.126 118.291 112.858 118.379 112.541C118.467 112.224 118.426 111.886 118.265 111.599C118.235 111.546 118.2 111.495 118.163 111.446L116.026 108.058C115.857 107.861 115.623 107.731 115.366 107.691C115.11 107.65 114.848 107.702 114.626 107.837L110.354 110.341C110.153 110.434 109.996 110.6 109.914 110.806C109.831 111.011 109.831 111.24 109.911 111.446L112.342 115.203C112.481 115.436 112.7 115.61 112.958 115.691C113.216 115.772 113.496 115.756 113.743 115.644Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M110.944 124.853L114.996 122.496C115.281 122.334 115.491 122.064 115.578 121.748C115.665 121.431 115.623 121.092 115.461 120.806C115.432 120.755 115.4 120.707 115.364 120.661L113.227 117.271C113.058 117.075 112.824 116.945 112.568 116.904C112.311 116.864 112.049 116.916 111.827 117.05L107.555 119.555C107.354 119.648 107.197 119.815 107.115 120.02C107.032 120.226 107.032 120.455 107.112 120.661L109.544 124.417C109.683 124.649 109.902 124.821 110.161 124.902C110.419 124.982 110.698 124.965 110.944 124.853Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M117.279 121.243L121.33 118.886C121.472 118.806 121.596 118.698 121.696 118.57C121.796 118.442 121.87 118.295 121.913 118.138C121.957 117.981 121.969 117.817 121.949 117.656C121.928 117.494 121.877 117.338 121.796 117.197C121.767 117.146 121.735 117.097 121.699 117.05L119.563 113.662C119.393 113.465 119.159 113.335 118.903 113.295C118.647 113.254 118.384 113.306 118.162 113.441L113.889 115.945C113.689 116.038 113.532 116.205 113.45 116.41C113.368 116.616 113.367 116.844 113.448 117.05L115.879 120.807C116.009 121.048 116.228 121.229 116.49 121.31C116.752 121.392 117.035 121.368 117.279 121.243V121.243Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M120.004 111.961L124.055 109.604C124.197 109.524 124.321 109.416 124.421 109.288C124.521 109.16 124.595 109.013 124.638 108.856C124.681 108.699 124.693 108.535 124.673 108.374C124.653 108.212 124.601 108.056 124.521 107.915C124.492 107.864 124.46 107.815 124.424 107.768L122.287 104.38C122.118 104.183 121.884 104.053 121.628 104.013C121.371 103.972 121.109 104.024 120.887 104.159L116.614 106.663C116.414 106.757 116.257 106.923 116.174 107.128C116.092 107.334 116.092 107.563 116.173 107.768L118.604 111.525C118.734 111.766 118.953 111.947 119.215 112.029C119.477 112.11 119.76 112.086 120.004 111.961V111.961Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M126.339 108.352L130.391 105.994C130.532 105.914 130.656 105.806 130.756 105.678C130.856 105.55 130.93 105.403 130.973 105.246C131.016 105.089 131.028 104.925 131.008 104.764C130.988 104.602 130.936 104.446 130.856 104.305C130.827 104.254 130.795 104.205 130.759 104.159L128.622 100.77C128.453 100.574 128.219 100.444 127.963 100.404C127.706 100.363 127.444 100.415 127.222 100.549L122.95 103.054C122.749 103.147 122.592 103.313 122.51 103.519C122.428 103.724 122.427 103.953 122.508 104.159L124.939 107.916C125.078 108.148 125.297 108.32 125.556 108.401C125.814 108.481 126.093 108.464 126.339 108.352Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M123.614 117.56L127.665 115.202C127.806 115.122 127.931 115.015 128.031 114.887C128.131 114.758 128.205 114.611 128.248 114.455C128.291 114.298 128.303 114.134 128.283 113.973C128.263 113.811 128.211 113.655 128.131 113.514C128.102 113.462 128.069 113.413 128.034 113.367L125.897 109.978C125.728 109.782 125.494 109.652 125.237 109.611C124.981 109.571 124.719 109.622 124.497 109.757L120.224 112.262C120.024 112.355 119.866 112.521 119.784 112.727C119.702 112.932 119.702 113.161 119.782 113.367L122.213 117.123C122.356 117.352 122.576 117.521 122.832 117.602C123.089 117.682 123.367 117.667 123.614 117.56V117.56Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M129.949 113.951L134.001 111.594C134.142 111.514 134.266 111.406 134.366 111.278C134.466 111.15 134.54 111.003 134.583 110.846C134.626 110.689 134.638 110.525 134.618 110.364C134.598 110.202 134.546 110.046 134.466 109.905C134.437 109.854 134.405 109.805 134.369 109.758L132.232 106.37C132.063 106.173 131.829 106.043 131.573 106.003C131.316 105.962 131.054 106.014 130.832 106.149L126.56 108.653C126.359 108.747 126.202 108.913 126.12 109.118C126.038 109.324 126.037 109.553 126.117 109.758L128.549 113.515C128.703 113.73 128.923 113.889 129.176 113.968C129.428 114.046 129.7 114.041 129.949 113.951V113.951Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M114.405 130.378L118.456 128.021C118.598 127.94 118.722 127.833 118.822 127.705C118.922 127.576 118.996 127.429 119.04 127.273C119.083 127.116 119.095 126.952 119.075 126.79C119.055 126.629 119.003 126.473 118.922 126.331C118.893 126.28 118.861 126.231 118.825 126.185L116.689 122.796C116.519 122.6 116.285 122.47 116.029 122.429C115.773 122.389 115.51 122.441 115.289 122.575L111.016 125.08C110.815 125.173 110.658 125.34 110.576 125.545C110.494 125.75 110.493 125.979 110.574 126.185L113.005 129.942C113.124 130.182 113.334 130.366 113.589 130.452C113.844 130.538 114.122 130.519 114.363 130.4C114.377 130.392 114.392 130.386 114.405 130.378Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M120.667 126.768L124.719 124.411C124.86 124.33 124.985 124.223 125.085 124.095C125.185 123.966 125.258 123.819 125.301 123.663C125.345 123.506 125.357 123.342 125.336 123.18C125.316 123.019 125.265 122.863 125.184 122.722C125.156 122.67 125.123 122.621 125.087 122.575L122.951 119.186C122.781 118.99 122.548 118.86 122.291 118.819C122.035 118.779 121.773 118.83 121.551 118.965L117.278 121.47C117.078 121.563 116.92 121.729 116.838 121.935C116.756 122.14 116.755 122.369 116.836 122.575L119.268 126.332C119.407 126.564 119.626 126.736 119.884 126.817C120.142 126.897 120.421 126.88 120.667 126.768V126.768Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M118.015 135.829L122.066 133.473C122.208 133.392 122.332 133.285 122.432 133.156C122.532 133.028 122.606 132.881 122.65 132.724C122.693 132.567 122.705 132.403 122.685 132.242C122.665 132.08 122.613 131.924 122.532 131.783C122.504 131.732 122.471 131.683 122.435 131.637L120.299 128.248C120.129 128.051 119.895 127.921 119.639 127.881C119.383 127.84 119.12 127.892 118.898 128.027L114.626 130.531C114.425 130.625 114.268 130.791 114.186 130.997C114.104 131.202 114.103 131.431 114.184 131.637L116.615 135.393C116.734 135.634 116.944 135.817 117.199 135.903C117.454 135.989 117.732 135.971 117.973 135.851C117.987 135.844 118.002 135.837 118.015 135.829Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M124.277 132.219L128.328 129.862C128.47 129.782 128.595 129.675 128.695 129.547C128.795 129.419 128.869 129.272 128.913 129.116C128.957 128.959 128.969 128.795 128.95 128.634C128.93 128.472 128.879 128.316 128.799 128.174C128.769 128.12 128.734 128.069 128.696 128.02L126.558 124.632C126.389 124.436 126.155 124.306 125.898 124.265C125.642 124.225 125.38 124.276 125.158 124.411L120.885 126.915C120.684 127.009 120.527 127.175 120.445 127.38C120.363 127.586 120.362 127.815 120.443 128.02L122.874 131.777C123.016 132.007 123.235 132.178 123.493 132.26C123.751 132.341 124.029 132.326 124.277 132.219Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M126.929 123.084L130.98 120.728C131.122 120.648 131.247 120.541 131.347 120.413C131.447 120.285 131.522 120.138 131.565 119.981C131.609 119.824 131.621 119.661 131.602 119.499C131.582 119.338 131.531 119.181 131.451 119.04C131.421 118.986 131.387 118.934 131.349 118.886L129.212 115.497C129.042 115.301 128.809 115.171 128.552 115.131C128.296 115.09 128.034 115.142 127.812 115.276L123.54 117.781C123.339 117.874 123.182 118.041 123.1 118.246C123.017 118.451 123.017 118.68 123.097 118.886L125.528 122.642C125.67 122.872 125.889 123.043 126.146 123.124C126.403 123.205 126.681 123.191 126.929 123.084Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M133.263 119.476L137.315 117.119C137.457 117.038 137.581 116.931 137.681 116.803C137.781 116.674 137.854 116.527 137.898 116.371C137.941 116.214 137.953 116.05 137.933 115.888C137.913 115.727 137.861 115.571 137.78 115.43C137.752 115.378 137.719 115.329 137.683 115.283L135.547 111.895C135.377 111.698 135.144 111.568 134.887 111.527C134.631 111.487 134.368 111.539 134.147 111.674L129.874 114.178C129.674 114.272 129.516 114.438 129.434 114.643C129.352 114.848 129.351 115.077 129.432 115.283L131.864 119.04C132.003 119.272 132.222 119.444 132.48 119.525C132.738 119.605 133.017 119.588 133.263 119.476V119.476Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M130.538 128.536L134.59 126.179C134.875 126.017 135.085 125.748 135.172 125.431C135.259 125.114 135.217 124.775 135.055 124.489C135.026 124.438 134.994 124.39 134.958 124.344L132.821 120.955C132.652 120.758 132.418 120.628 132.162 120.588C131.905 120.547 131.643 120.599 131.421 120.733L127.149 123.238C126.948 123.332 126.791 123.498 126.709 123.703C126.627 123.909 126.626 124.138 126.706 124.344L129.138 128.1C129.28 128.329 129.5 128.498 129.757 128.578C130.014 128.658 130.291 128.643 130.538 128.536V128.536Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M136.873 124.926L140.925 122.569C141.067 122.488 141.191 122.381 141.291 122.252C141.391 122.124 141.464 121.977 141.508 121.82C141.551 121.664 141.563 121.5 141.543 121.338C141.522 121.177 141.471 121.021 141.39 120.879C141.362 120.828 141.329 120.78 141.293 120.734L139.157 117.345C138.987 117.148 138.753 117.018 138.497 116.977C138.241 116.937 137.978 116.989 137.757 117.123L133.484 119.628C133.284 119.721 133.126 119.888 133.044 120.093C132.962 120.299 132.961 120.528 133.042 120.734L135.474 124.49C135.616 124.719 135.835 124.888 136.092 124.968C136.349 125.048 136.627 125.033 136.873 124.926V124.926Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M121.625 141.354L125.677 138.996C125.818 138.916 125.942 138.809 126.043 138.681C126.143 138.552 126.216 138.405 126.26 138.249C126.303 138.092 126.315 137.928 126.295 137.766C126.275 137.605 126.223 137.449 126.142 137.308C126.114 137.257 126.081 137.208 126.045 137.161L123.909 133.773C123.739 133.576 123.506 133.446 123.249 133.406C122.993 133.365 122.73 133.417 122.509 133.552L118.236 136.056C118.035 136.15 117.878 136.316 117.796 136.521C117.714 136.727 117.713 136.956 117.794 137.161L120.225 140.918C120.364 141.15 120.584 141.322 120.842 141.403C121.1 141.483 121.379 141.466 121.625 141.354V141.354Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M127.96 137.744L132.011 135.387C132.153 135.307 132.277 135.199 132.377 135.071C132.477 134.943 132.551 134.796 132.594 134.639C132.637 134.482 132.649 134.318 132.629 134.156C132.609 133.995 132.557 133.839 132.477 133.697C132.448 133.646 132.416 133.598 132.38 133.552L130.241 130.156C130.072 129.959 129.838 129.829 129.582 129.789C129.325 129.748 129.063 129.8 128.841 129.935L124.569 132.439C124.368 132.532 124.211 132.699 124.129 132.904C124.046 133.109 124.045 133.338 124.126 133.544L126.558 137.301C126.696 137.534 126.915 137.709 127.174 137.791C127.433 137.873 127.713 137.856 127.96 137.744Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M134.222 134.06L138.273 131.704C138.415 131.624 138.539 131.516 138.639 131.388C138.739 131.259 138.813 131.113 138.856 130.956C138.899 130.799 138.911 130.635 138.891 130.473C138.871 130.312 138.819 130.156 138.739 130.014C138.71 129.963 138.678 129.915 138.642 129.868L136.505 126.479C136.336 126.283 136.102 126.153 135.846 126.112C135.589 126.072 135.327 126.124 135.105 126.258L130.832 128.763C130.632 128.856 130.474 129.023 130.392 129.228C130.31 129.434 130.31 129.663 130.39 129.868L132.822 133.624C132.961 133.856 133.18 134.029 133.438 134.11C133.697 134.19 133.976 134.173 134.222 134.06Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M140.484 130.451L144.535 128.094C144.677 128.014 144.801 127.906 144.901 127.778C145.001 127.65 145.075 127.503 145.118 127.346C145.161 127.189 145.173 127.025 145.153 126.864C145.133 126.703 145.081 126.547 145 126.405C144.972 126.354 144.939 126.305 144.903 126.259L142.765 122.863C142.595 122.667 142.361 122.537 142.105 122.497C141.849 122.456 141.587 122.508 141.365 122.642L137.092 125.146C136.892 125.24 136.734 125.406 136.652 125.612C136.57 125.817 136.569 126.046 136.65 126.252L139.081 130.008C139.223 130.238 139.442 130.41 139.7 130.491C139.958 130.573 140.236 130.559 140.484 130.451V130.451Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M119.046 89.9348L143.208 128.756L119.046 89.9348Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M119.046 89.9348L143.208 128.756L119.046 89.9348Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M117.426 90.894L141.588 129.714L117.426 90.894Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M117.426 90.894L141.588 129.714L117.426 90.894Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M112.784 93.619L136.947 132.439L112.784 93.619Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M112.784 93.619L136.947 132.439L112.784 93.619Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M111.238 94.6499L135.4 133.471L111.238 94.6499Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M111.238 94.6499L135.4 133.471L111.238 94.6499Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M106.596 97.2285L130.759 136.049L106.596 97.2285Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M106.596 97.2285L130.759 136.049L106.596 97.2285Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M104.976 98.26L129.139 137.081L104.976 98.26Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M104.976 98.26L129.139 137.081L104.976 98.26Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M100.334 100.911L124.497 139.732L100.334 100.911Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M100.334 100.911L124.497 139.732L100.334 100.911Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M98.788 101.87L122.951 140.691L98.788 101.87Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M98.788 101.87L122.951 140.691L98.788 101.87Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M121.036 88.5369L121.11 88.6104L95.8422 103.269L95.7687 103.196L121.036 88.5369Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M121.109 88.6097L121.182 88.6826L96.0627 103.342L95.9892 103.196L121.109 88.6097Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M95.8418 103.268L95.7677 103.195L120.299 142.237L120.521 142.384L95.8418 103.268Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M95.842 103.268L95.9883 103.195L120.666 142.311L120.519 142.384L95.842 103.268Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M121.034 88.8303L120.887 88.9038L145.712 127.572L145.859 127.646L121.034 88.8303Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M120.961 88.6826L121.108 88.6097L146.006 127.507L145.86 127.654L120.961 88.6826Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M145.639 127.431H145.786L120.593 142.233V142.085L145.639 127.431Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M145.786 127.431L145.859 127.652L120.666 142.312L120.593 142.238L145.786 127.431Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M69.0271 62.9005L68.1439 64.1524L118.457 145.331L119.341 144.079L69.0271 62.9005Z",
    fill: "#3D3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M119.34 144.079L118.457 145.331L145.787 129.419L147.039 128.092L119.34 144.079Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M95.9882 49.1249L70.8682 63.7843L95.5466 102.606L120.593 87.8729L95.9882 49.1249Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M75.2901 68.7935L79.3413 66.4365C79.483 66.3566 79.6077 66.2496 79.7081 66.1215C79.8085 65.9934 79.8826 65.8468 79.9264 65.6901C79.9701 65.5333 79.9825 65.3695 79.9629 65.2079C79.9433 65.0464 79.8921 64.8903 79.8122 64.7485C79.7819 64.695 79.7478 64.6438 79.71 64.5953L77.5736 61.2068C77.404 61.0103 77.1703 60.8803 76.9139 60.8398C76.6576 60.7993 76.3951 60.851 76.1733 60.9857L71.9004 63.4903C71.7 63.5837 71.5427 63.75 71.4606 63.9553C71.3786 64.1606 71.3779 64.3895 71.4587 64.5953L73.8898 68.3519C74.0432 68.568 74.263 68.7282 74.5157 68.8079C74.7685 68.8876 75.0404 68.8826 75.2901 68.7935Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M81.6247 65.1097L85.676 62.7527C85.8175 62.6726 85.9419 62.5652 86.0419 62.4369C86.142 62.3086 86.2157 62.1619 86.259 62.005C86.3023 61.8482 86.3142 61.6844 86.2941 61.5229C86.274 61.3615 86.2223 61.2056 86.1419 61.0641C86.1129 61.013 86.0804 60.9638 86.0447 60.9171L83.9082 57.5293C83.7387 57.3328 83.505 57.2027 83.2486 57.1622C82.9922 57.1218 82.7298 57.1735 82.508 57.3082L78.2351 59.8128C78.0347 59.906 77.8774 60.0722 77.7954 60.2774C77.7133 60.4826 77.7126 60.7114 77.7934 60.9171L80.2245 64.6737C80.3637 64.9056 80.5833 65.0783 80.8415 65.1587C81.0997 65.2391 81.3785 65.2217 81.6247 65.1097V65.1097Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M78.8993 74.2449L82.9505 71.8885C83.1061 71.8012 83.2409 71.6812 83.3458 71.5369C83.4507 71.3926 83.5232 71.2273 83.5582 71.0523C83.5932 70.8774 83.59 70.6969 83.5487 70.5233C83.5075 70.3498 83.4292 70.1871 83.3192 70.0467L81.1828 66.6582C81.0132 66.4617 80.7795 66.3316 80.5232 66.2911C80.2668 66.2507 80.0044 66.3024 79.7825 66.4371L75.5096 68.9404C75.3092 69.0342 75.152 69.2007 75.0699 69.4062C74.9879 69.6117 74.9872 69.8407 75.068 70.0467L77.4991 73.8032C77.6524 74.0194 77.8722 74.1796 78.125 74.2593C78.3777 74.339 78.6497 74.3339 78.8993 74.2449Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M85.2348 70.5619L89.2853 68.2043C89.4269 68.1241 89.5512 68.0168 89.6513 67.8885C89.7513 67.7602 89.8251 67.6134 89.8684 67.4566C89.9116 67.2997 89.9236 67.1359 89.9035 66.9744C89.8834 66.813 89.8316 66.6571 89.7512 66.5156C89.7223 66.4647 89.6898 66.4158 89.6541 66.3693L87.5157 62.974C87.3462 62.7775 87.1125 62.6474 86.8561 62.6069C86.5997 62.5665 86.3374 62.6182 86.1155 62.7528L81.8432 65.2562C81.6426 65.3498 81.4852 65.5163 81.403 65.7217C81.3207 65.9272 81.3198 66.1563 81.4003 66.3624L83.832 70.1184C83.9565 70.3623 84.1728 70.5467 84.4333 70.6312C84.6938 70.7156 84.9771 70.6932 85.2211 70.5687L85.2348 70.5619Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M87.8865 61.4273L91.9377 59.0704C92.0795 58.9905 92.2041 58.8834 92.3045 58.7553C92.4049 58.6273 92.4791 58.4807 92.5228 58.3239C92.5665 58.1672 92.5789 58.0033 92.5593 57.8418C92.5398 57.6802 92.4885 57.5241 92.4086 57.3824C92.3785 57.3288 92.3443 57.2776 92.3064 57.2292L90.17 53.84C90.0004 53.6437 89.7666 53.5137 89.5103 53.4732C89.254 53.4327 88.9916 53.4844 88.7698 53.6189L84.4968 56.1235C84.2964 56.217 84.1391 56.3835 84.0571 56.5889C83.975 56.7943 83.9743 57.0232 84.0552 57.2291L86.4863 60.9857C86.6116 61.2292 86.8285 61.4131 87.0893 61.4968C87.3501 61.5805 87.6334 61.5573 87.8771 61.4323L87.8865 61.4273Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M94.1478 57.8164L98.1996 55.4607C98.4854 55.2982 98.6949 55.0288 98.7822 54.7118C98.8694 54.3948 98.8273 54.0561 98.6649 53.7702C98.6363 53.7192 98.6038 53.6705 98.5677 53.6245L96.4313 50.236C96.2617 50.0395 96.028 49.9094 95.7717 49.869C95.5153 49.8285 95.2529 49.8802 95.031 50.0149L90.7587 52.5195C90.5583 52.6128 90.4009 52.7791 90.3187 52.9844C90.2366 53.1897 90.2358 53.4186 90.3165 53.6245L92.7482 57.381C92.8904 57.6095 93.11 57.7793 93.367 57.8592C93.6239 57.9391 93.9011 57.924 94.1478 57.8164V57.8164Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M91.4967 66.8788L95.5479 64.5218C95.6895 64.4416 95.8138 64.3342 95.9139 64.2058C96.0139 64.0775 96.0877 63.9307 96.1309 63.7738C96.1742 63.6169 96.1862 63.453 96.1661 63.2915C96.146 63.13 96.0942 62.9741 96.0138 62.8326C95.985 62.7815 95.9525 62.7326 95.9166 62.6862L93.7802 59.2978C93.6107 59.1011 93.377 58.971 93.1206 58.9305C92.8642 58.89 92.6017 58.9418 92.3799 59.0766L88.107 61.5812C87.9066 61.6746 87.7493 61.8409 87.6673 62.0462C87.5852 62.2515 87.5845 62.4804 87.6654 62.6862L90.0965 66.4428C90.2266 66.684 90.446 66.8648 90.7077 66.9463C90.9694 67.0278 91.2526 67.0035 91.4967 66.8788V66.8788Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M97.8313 63.2686L101.883 60.9122C102.024 60.8323 102.149 60.7252 102.249 60.5972C102.35 60.4691 102.424 60.3225 102.468 60.1657C102.511 60.009 102.524 59.8452 102.504 59.6836C102.485 59.5221 102.433 59.366 102.353 59.2242C102.323 59.1704 102.289 59.119 102.251 59.0704L100.115 55.6819C99.9452 55.4855 99.7115 55.3556 99.4551 55.3151C99.1988 55.2746 98.9365 55.3262 98.7146 55.4608L94.4416 57.9654C94.2412 58.0588 94.084 58.2251 94.0019 58.4304C93.9199 58.6357 93.9192 58.8646 94 59.0704L96.4311 62.8269C96.5693 63.0599 96.7885 63.2338 97.0468 63.3152C97.3052 63.3967 97.5845 63.3801 97.8313 63.2686Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M82.4348 79.77L86.4866 77.413C86.6281 77.3326 86.7523 77.2252 86.8523 77.0968C86.9523 76.9684 87.026 76.8216 87.0692 76.6648C87.1124 76.5079 87.1243 76.344 87.1041 76.1826C87.084 76.0211 87.0323 75.8652 86.9519 75.7237C86.9232 75.6726 86.8907 75.6237 86.8547 75.5774L84.7183 72.1889C84.5487 71.9927 84.3151 71.8628 84.0589 71.8224C83.8027 71.7819 83.5405 71.8334 83.3186 71.9678L79.0457 74.4724C78.8453 74.5657 78.6879 74.732 78.6057 74.9373C78.5236 75.1426 78.5228 75.3715 78.6035 75.5774L81.0352 79.3339C81.1742 79.5659 81.3937 79.7385 81.6518 79.8189C81.9099 79.8993 82.1887 79.8819 82.4348 79.77V79.77Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M88.6964 76.087L92.7482 73.7301C92.8897 73.6497 93.0139 73.5423 93.1139 73.4139C93.2139 73.2855 93.2876 73.1387 93.3308 72.9818C93.374 72.8249 93.3859 72.6611 93.3657 72.4996C93.3456 72.3382 93.2939 72.1823 93.2135 72.0408C93.1847 71.9897 93.1523 71.9408 93.1163 71.8944L90.9799 68.506C90.8103 68.3095 90.5766 68.1794 90.3202 68.1389C90.0639 68.0984 89.8015 68.1501 89.5796 68.2848L85.3073 70.7894C85.1068 70.8828 84.9495 71.049 84.8673 71.2543C84.7851 71.4596 84.7844 71.6885 84.8651 71.8944L87.2961 75.651C87.4262 75.8923 87.6456 76.0731 87.9073 76.1546C88.1691 76.2361 88.4523 76.2119 88.6964 76.087V76.087Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M85.971 85.295L90.0222 82.938C90.164 82.8581 90.2887 82.751 90.3891 82.623C90.4895 82.4949 90.5637 82.3483 90.6074 82.1915C90.6511 82.0348 90.6635 81.8709 90.6439 81.7094C90.6243 81.5478 90.5731 81.3917 90.4931 81.25C90.4629 81.1965 90.4287 81.1453 90.391 81.0968L88.252 77.7064C88.0825 77.5101 87.8489 77.3801 87.5927 77.3396C87.3365 77.2991 87.0742 77.3507 86.8524 77.4853L82.5795 79.9899C82.379 80.0834 82.2217 80.2498 82.1396 80.4552C82.0574 80.6606 82.0566 80.8895 82.1372 81.0955L84.569 84.8521C84.6935 85.0959 84.9099 85.2803 85.1703 85.3646C85.4308 85.4489 85.7141 85.4264 85.958 85.3018L85.971 85.295Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M92.3054 81.7582L96.3572 79.4019C96.643 79.2395 96.8525 78.9702 96.9398 78.6533C97.027 78.3364 96.9849 77.9978 96.8225 77.712C96.7937 77.6609 96.7613 77.612 96.7253 77.5656L94.5888 74.1772C94.4191 73.9809 94.1855 73.851 93.9292 73.8106C93.6729 73.7701 93.4106 73.8216 93.1886 73.956L88.9163 76.4606C88.7158 76.554 88.5585 76.7202 88.4763 76.9255C88.3942 77.1308 88.3933 77.3597 88.4741 77.5656L90.9051 81.3222C91.0561 81.541 91.2762 81.7029 91.53 81.7819C91.7838 81.861 92.0569 81.8526 92.3054 81.7582V81.7582Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M95.0308 72.4766L99.0827 70.1196C99.2242 70.0393 99.3484 69.9319 99.4484 69.8035C99.5484 69.6751 99.622 69.5283 99.6653 69.3714C99.7085 69.2145 99.7203 69.0507 99.7002 68.8892C99.6801 68.7278 99.6284 68.5719 99.548 68.4304C99.5194 68.3794 99.4869 68.3307 99.4508 68.2846L97.3143 64.8949C97.1447 64.6985 96.911 64.5686 96.6546 64.5282C96.3982 64.4878 96.1359 64.5396 95.9141 64.6744L91.6418 67.179C91.4413 67.2725 91.2839 67.4389 91.2018 67.6443C91.1196 67.8497 91.1188 68.0787 91.1995 68.2846L93.6313 72.0412C93.7822 72.2599 94.0022 72.4216 94.2559 72.5005C94.5096 72.5795 94.7825 72.571 95.0308 72.4766Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M101.293 68.7935L105.345 66.4371C105.631 66.2756 105.841 66.0069 105.929 65.6902C106.018 65.3736 105.976 65.0348 105.815 64.7485C105.785 64.6949 105.751 64.6437 105.713 64.5953L103.576 61.2068C103.407 61.0103 103.173 60.8803 102.917 60.8398C102.66 60.7993 102.398 60.851 102.176 60.9857L97.9037 63.4903C97.7032 63.5837 97.5459 63.7499 97.4637 63.9552C97.3815 64.1605 97.3807 64.3894 97.4615 64.5953L99.8925 68.3518C100.034 68.5813 100.253 68.7522 100.51 68.8333C100.768 68.9144 101.045 68.9003 101.293 68.7935V68.7935Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M98.6409 78.001L102.693 75.6434C102.979 75.481 103.188 75.2117 103.275 74.8948C103.363 74.5779 103.32 74.2394 103.158 73.9536C103.129 73.9026 103.097 73.8538 103.061 73.8078L100.924 70.4187C100.755 70.2222 100.521 70.0921 100.265 70.0516C100.008 70.0112 99.746 70.0629 99.5242 70.1976L95.2519 72.7022C95.0514 72.7956 94.894 72.962 94.8119 73.1674C94.7297 73.3728 94.7289 73.6018 94.8096 73.8078L97.2414 77.5643C97.3802 77.7964 97.5997 77.9691 97.8578 78.0497C98.116 78.1302 98.3948 78.1129 98.6409 78.001Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M104.977 74.3926L109.028 72.0344C109.169 71.954 109.294 71.8466 109.394 71.7182C109.494 71.5898 109.568 71.4429 109.611 71.286C109.654 71.129 109.666 70.9651 109.646 70.8036C109.626 70.642 109.574 70.4861 109.494 70.3445C109.465 70.2935 109.432 70.2446 109.397 70.1981L107.26 66.8103C107.091 66.6137 106.857 66.4835 106.601 66.443C106.344 66.4024 106.082 66.4539 105.86 66.5886L101.587 69.0931C101.387 69.1865 101.229 69.3528 101.147 69.5581C101.065 69.7635 101.065 69.9923 101.145 70.1981L103.576 73.9547C103.715 74.1869 103.935 74.3598 104.193 74.4406C104.451 74.5213 104.73 74.5043 104.977 74.3926V74.3926Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M89.3598 90.8939L93.411 88.5363C93.5527 88.4564 93.6774 88.3494 93.7777 88.2214C93.8781 88.0934 93.9523 87.9469 93.996 87.7902C94.0398 87.6335 94.0522 87.4697 94.0326 87.3082C94.013 87.1467 93.9618 86.9906 93.8819 86.8489C93.8518 86.7951 93.8176 86.7437 93.7797 86.695L91.6433 83.3066C91.4736 83.1102 91.2399 82.9803 90.9836 82.9398C90.7273 82.8993 90.4649 82.9509 90.243 83.0855L85.9701 85.5901C85.7697 85.6835 85.6124 85.8498 85.5304 86.0551C85.4483 86.2604 85.4476 86.4893 85.5284 86.695L87.9596 90.4516C88.1129 90.6678 88.3327 90.8279 88.5854 90.9078C88.8382 90.9876 89.1101 90.9827 89.3598 90.8939V90.8939Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M95.6947 87.2095L99.7465 84.8525C100.032 84.6899 100.242 84.4206 100.329 84.1036C100.416 83.7866 100.374 83.4479 100.212 83.162C100.183 83.111 100.151 83.0623 100.115 83.0163L97.9781 79.6278C97.8087 79.4312 97.575 79.3011 97.3186 79.2605C97.0623 79.2199 96.7998 79.2714 96.5779 79.4061L92.305 81.9106C92.1045 82.0042 91.9473 82.1706 91.8652 82.376C91.7832 82.5814 91.7825 82.8104 91.8633 83.0163L94.2944 86.7728C94.4299 87.0086 94.6493 87.1846 94.909 87.2656C95.1686 87.3465 95.4492 87.3265 95.6947 87.2095V87.2095Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M92.9702 96.3452L97.0214 93.9882C97.163 93.9079 97.2874 93.8005 97.3874 93.6721C97.4874 93.5436 97.5612 93.3968 97.6045 93.2398C97.6477 93.0829 97.6597 92.919 97.6396 92.7575C97.6195 92.5959 97.5677 92.4399 97.4873 92.2984C97.4583 92.2476 97.4259 92.1989 97.3901 92.1526L95.2537 88.7635C95.0841 88.567 94.8504 88.437 94.5941 88.3965C94.3377 88.356 94.0753 88.4077 93.8534 88.5424L89.5805 91.047C89.3801 91.1406 89.2229 91.307 89.1408 91.5124C89.0588 91.7178 89.0581 91.9467 89.1389 92.1526L91.57 95.9092C91.7243 96.1242 91.9444 96.2831 92.1971 96.3617C92.4497 96.4404 92.7211 96.4346 92.9702 96.3452V96.3452Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M99.3044 92.7345L103.356 90.3781C103.642 90.2165 103.853 89.9479 103.941 89.6312C104.029 89.3145 103.988 88.9758 103.826 88.6895C103.796 88.6359 103.762 88.5846 103.724 88.5363L101.588 85.1478C101.418 84.9513 101.185 84.8213 100.928 84.7808C100.672 84.7403 100.409 84.792 100.188 84.9267L95.9147 87.4307C95.7143 87.5242 95.557 87.6907 95.475 87.896C95.393 88.1014 95.3923 88.3304 95.473 88.5363L97.9041 92.2929C98.0542 92.5128 98.2739 92.6759 98.5278 92.756C98.7818 92.8361 99.0552 92.8285 99.3044 92.7345V92.7345Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M101.956 83.5265L106.007 81.1701C106.293 81.0086 106.504 80.74 106.592 80.4233C106.68 80.1066 106.639 79.7679 106.478 79.4815C106.448 79.428 106.414 79.3768 106.376 79.3283L104.239 75.9398C104.07 75.7432 103.836 75.6131 103.58 75.5725C103.323 75.5319 103.061 75.5835 102.839 75.7181L98.5661 78.2227C98.3657 78.3162 98.2085 78.4827 98.1265 78.688C98.0444 78.8934 98.0438 79.1224 98.1245 79.3283L100.556 83.0848C100.681 83.3285 100.898 83.5124 101.159 83.5962C101.419 83.6799 101.703 83.6566 101.947 83.5314L101.956 83.5265Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M108.218 79.9174L112.269 77.5604C112.41 77.4802 112.535 77.3728 112.635 77.2444C112.735 77.1161 112.809 76.9692 112.852 76.8124C112.895 76.6555 112.907 76.4916 112.887 76.3301C112.867 76.1686 112.815 76.0127 112.735 75.8712C112.706 75.8199 112.673 75.7708 112.638 75.7242L110.501 72.3357C110.332 72.1392 110.098 72.0092 109.841 71.9687C109.585 71.9282 109.323 71.9799 109.101 72.1146L104.828 74.6192C104.628 74.7127 104.47 74.8789 104.388 75.0842C104.306 75.2895 104.305 75.5184 104.386 75.7242L106.817 79.4808C106.96 79.7092 107.179 79.8789 107.436 79.959C107.693 80.0391 107.971 80.0244 108.218 79.9174V79.9174Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M105.566 89.0519L109.617 86.6949C109.758 86.6147 109.883 86.5073 109.983 86.3789C110.083 86.2506 110.157 86.1038 110.2 85.9469C110.243 85.79 110.255 85.6261 110.235 85.4646C110.215 85.3031 110.163 85.1472 110.083 85.0057C110.054 84.9547 110.021 84.9058 109.986 84.8593L107.849 81.4702C107.68 81.2738 107.446 81.1438 107.189 81.1034C106.933 81.0631 106.671 81.1149 106.449 81.2497L102.176 83.7543C101.976 83.8477 101.818 84.014 101.736 84.2193C101.654 84.4246 101.654 84.6535 101.734 84.8593L104.165 88.6158C104.316 88.8347 104.536 88.9965 104.79 89.0756C105.044 89.1546 105.317 89.1463 105.566 89.0519Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M111.901 85.3684L115.952 83.0114C116.094 82.9315 116.219 82.8244 116.319 82.6964C116.419 82.5683 116.494 82.4217 116.537 82.2649C116.581 82.1082 116.593 81.9444 116.574 81.7828C116.554 81.6213 116.503 81.4652 116.423 81.3234C116.393 81.2698 116.359 81.2186 116.321 81.1702L114.185 77.7811C114.015 77.5847 113.781 77.4547 113.525 77.4143C113.269 77.3738 113.006 77.4254 112.784 77.56L108.511 80.0646C108.311 80.158 108.154 80.3245 108.072 80.5299C107.989 80.7353 107.989 80.9643 108.07 81.1702L110.501 84.9261C110.626 85.1697 110.843 85.3536 111.104 85.4375C111.365 85.5213 111.648 85.4983 111.892 85.3733L111.901 85.3684Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M96.5787 101.796L100.63 99.4393C100.772 99.359 100.896 99.2516 100.996 99.1232C101.096 98.9949 101.17 98.8481 101.213 98.6912C101.256 98.5343 101.268 98.3704 101.248 98.2089C101.228 98.0475 101.176 97.8915 101.096 97.75C101.067 97.6989 101.035 97.65 100.999 97.6036L98.8622 94.2152C98.6928 94.0185 98.459 93.8884 98.2026 93.8479C97.9462 93.8074 97.6838 93.8592 97.462 93.9941L93.189 96.498C92.9886 96.5916 92.8314 96.758 92.7494 96.9634C92.6674 97.1688 92.6666 97.3977 92.7474 97.6036L95.1785 101.36C95.3086 101.601 95.528 101.782 95.7897 101.864C96.0514 101.945 96.3347 101.921 96.5787 101.796V101.796Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M102.914 98.1864L106.965 95.8301C107.252 95.6686 107.462 95.3999 107.55 95.0833C107.639 94.7666 107.597 94.4278 107.436 94.1415C107.406 94.088 107.372 94.0367 107.334 93.9882L105.195 90.5985C105.025 90.4022 104.792 90.2722 104.536 90.2317C104.279 90.1912 104.017 90.2428 103.795 90.3774L99.5224 92.882C99.322 92.9753 99.1646 93.1416 99.0824 93.3469C99.0003 93.5522 98.9995 93.7811 99.0802 93.987L101.512 97.7429C101.653 97.9733 101.873 98.145 102.13 98.2265C102.388 98.308 102.666 98.2937 102.914 98.1864V98.1864Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M109.176 94.5029L113.227 92.1459C113.368 92.066 113.493 91.959 113.594 91.8309C113.694 91.7028 113.768 91.5562 113.812 91.3995C113.856 91.2427 113.868 91.0789 113.848 90.9173C113.829 90.7558 113.778 90.5997 113.698 90.4579C113.667 90.4044 113.633 90.3532 113.595 90.3047L111.459 86.9156C111.289 86.7192 111.056 86.5893 110.799 86.5488C110.543 86.5083 110.281 86.5599 110.059 86.6945L105.786 89.1991C105.585 89.2927 105.428 89.4591 105.346 89.6645C105.264 89.8699 105.263 90.0988 105.344 90.3047L107.775 94.0612C107.917 94.2907 108.136 94.4617 108.393 94.5428C108.65 94.6238 108.928 94.6097 109.176 94.5029Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M115.51 90.8931L119.561 88.5361C119.703 88.4562 119.828 88.3491 119.928 88.2211C120.029 88.093 120.103 87.9464 120.146 87.7897C120.19 87.6329 120.203 87.4691 120.183 87.3075C120.163 87.146 120.112 86.9899 120.032 86.8481C120.002 86.7943 119.968 86.7429 119.93 86.6943L117.794 83.3058C117.624 83.1094 117.39 82.9795 117.134 82.939C116.878 82.8985 116.615 82.9501 116.393 83.0847L112.12 85.5893C111.92 85.6827 111.763 85.849 111.681 86.0543C111.599 86.2596 111.598 86.4885 111.679 86.6943L114.11 90.4508C114.251 90.6803 114.471 90.8513 114.728 90.9325C114.985 91.0137 115.263 90.9997 115.51 90.8931V90.8931Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M93.9997 50.3774L118.162 89.1976L93.9997 50.3774Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M93.9997 50.3774L118.162 89.1976L93.9997 50.3774Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M92.4529 51.4091L116.616 90.23L92.4529 51.4091Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M92.4529 51.4091L116.616 90.23L92.4529 51.4091Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M87.8117 54.1342L111.974 92.955L87.8117 54.1342Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M87.8117 54.1342L111.974 92.955L87.8117 54.1342Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M86.1919 55.0915L110.355 93.913L86.1919 55.0915Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M86.1919 55.0915L110.355 93.913L86.1919 55.0915Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M81.5501 57.7442L105.713 96.5651L81.5501 57.7442Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M81.5501 57.7442L105.713 96.5651L81.5501 57.7442Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M80.0034 58.7015L104.166 97.523L80.0034 58.7015Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M80.0034 58.7015L104.166 97.523L80.0034 58.7015Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M75.3631 61.3538L99.5258 100.175L75.3631 61.3538Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M75.3631 61.3538L99.5258 100.175L75.3631 61.3538Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    d: "M73.815 62.3105L97.9777 101.132L73.815 62.3105Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M73.815 62.3105L97.9777 101.132L73.815 62.3105Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M95.9901 48.9774L96.1365 49.0509L70.8682 63.7795L70.7218 63.706L95.9901 48.9774Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M96.1356 49.0508L96.2091 49.1978L71.0162 63.7837V63.7108L96.1356 49.0508Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M70.8684 63.7831L70.7214 63.7108L95.2522 102.679L95.5475 102.826L70.8684 63.7831Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    d: "M70.8688 63.7831L70.9423 63.7108L95.6201 102.826H95.546L70.8688 63.7831Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M95.9886 49.2726L95.9145 49.3455L120.666 88.0199L120.813 88.0934L95.9886 49.2726Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M95.9894 49.1243L96.1358 49.0502L121.035 87.9489L120.814 88.096L95.9894 49.1243Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M120.592 87.8735H120.739L95.62 102.676L95.5465 102.602L120.592 87.8735Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M120.741 87.8729L120.815 88.094L95.6204 102.828V102.676L120.741 87.8729Z",
    fill: "#E5E4DE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.97457
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    opacity: 0.97457,
    d: "M172.157 139.935L154.442 149.979L154.476 129.234L172.141 119.238L172.157 139.935Z",
    fill: "#B98D3A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.97457
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    opacity: 0.97457,
    d: "M68.1076 167.702L90.3634 180.273V134.363L68.1442 121.668L68.1076 167.702Z",
    fill: "#BB8C35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.97457
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    opacity: 0.97457,
    d: "M133.461 155.217L121.562 161.995L121.588 147.823L133.424 141.122L133.461 155.217Z",
    fill: "#B98D3A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.97457
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    opacity: 0.97457,
    d: "M133.461 177.44L121.648 184.007L121.587 164.493L133.423 157.793L133.461 177.44Z",
    fill: "#B98D3A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Busch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    d: "M113.995 198.495C122.053 198.495 128.584 202.281 128.584 206.952C128.584 211.623 122.053 215.409 113.995 215.409C105.938 215.409 99.4055 211.623 99.4055 206.952C99.4055 202.281 105.938 198.495 113.995 198.495Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M108.437 175.714C118.304 175.714 126.303 184.091 126.303 194.425C126.303 204.758 118.304 213.136 108.437 213.136C98.5695 213.136 90.5711 204.758 90.5711 194.425C90.5711 184.091 98.5695 175.714 108.437 175.714Z",
    fill: "#558835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M121.235 202.354C117.299 204.335 112.955 205.367 108.549 205.367C104.143 205.367 99.7983 204.335 95.8629 202.354C92.2686 200.345 90.5765 197.597 90.5765 194.849C90.4579 196.704 90.8853 198.554 91.806 200.169C92.7267 201.785 94.1004 203.095 95.7574 203.939C99.6925 205.92 104.037 206.952 108.443 206.952C112.849 206.952 117.193 205.92 121.128 203.939C122.587 203.119 123.828 201.962 124.747 200.564C125.667 199.167 126.239 197.569 126.415 195.905C126.093 198.338 124.294 200.557 121.235 202.354Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    d: "M119.432 190.933C116.022 192.653 112.257 193.549 108.438 193.549C104.618 193.549 100.853 192.653 97.4429 190.933C96.3145 190.399 95.3202 189.619 94.5334 188.65C93.7466 187.681 93.1873 186.547 92.8966 185.333C92.5784 187.871 94.0587 190.409 97.4429 192.311C100.853 194.031 104.619 194.927 108.438 194.927C112.257 194.927 116.022 194.031 119.432 192.311C122.815 190.407 124.295 187.765 123.978 185.333C123.688 186.547 123.128 187.681 122.342 188.65C121.555 189.619 120.561 190.399 119.432 190.933V190.933Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 172.177 99.9569)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 172.177 99.957)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M172.187 91.9451L171.564 98.3302H172.79L172.187 91.9451Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M172.187 107.907L171.564 101.522H172.79L172.187 107.907Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M180.016 99.9474L173.631 100.57L173.631 99.3443L180.016 99.9474Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M164.214 99.9474L170.599 100.57L170.599 99.3443L164.214 99.9474Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_2",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 104.389 68.3482)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_2",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 104.389 68.3483)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_2",
    d: "M104.398 60.3364L103.776 66.7215H105.001L104.398 60.3364Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_2",
    d: "M104.398 76.2986L103.776 69.9135H105.001L104.398 76.2986Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_2",
    d: "M112.227 68.3387L105.842 68.961L105.842 67.7356L112.227 68.3387Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_2",
    d: "M96.4253 68.3387L102.81 68.961L102.81 67.7356L96.4253 68.3387Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_3",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 151.01 28.1537)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_3",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 151.01 28.1538)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_3",
    d: "M151.02 20.1418L150.397 26.527H151.623L151.02 20.1418Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_3",
    d: "M151.02 36.1041L150.397 29.719H151.623L151.02 36.1041Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_3",
    d: "M158.849 28.1441L152.464 28.7664L152.464 27.5411L158.849 28.1441Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_3",
    d: "M143.047 28.1441L149.432 28.7664L149.432 27.5411L143.047 28.1441Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_4",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 122.351 37.8623)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_4",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 122.351 37.8624)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_4",
    d: "M122.36 29.8505L121.738 36.2356H122.964L122.36 29.8505Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_4",
    d: "M122.36 45.8127L121.738 39.4276H122.964L122.36 45.8127Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_4",
    d: "M130.19 37.8528L123.804 38.4751L123.804 37.2497L130.19 37.8528Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_4",
    d: "M114.387 37.8528L120.773 38.4751L120.773 37.2497L114.387 37.8528Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_5",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 178.562 74.8944)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_5",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 178.562 74.8945)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_5",
    d: "M178.572 66.8826L177.95 73.2677H179.175L178.572 66.8826Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_5",
    d: "M178.572 82.8449L177.95 76.4597H179.175L178.572 82.8449Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_5",
    d: "M186.401 74.8849L180.016 75.5072L180.016 74.2818L186.401 74.8849Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_5",
    d: "M170.599 74.8849L176.984 75.5072L176.984 74.2818L170.599 74.8849Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_6",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 105.661 90.2222)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_6",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 105.661 90.2223)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_6",
    d: "M105.67 82.2103L105.048 88.5954H106.273L105.67 82.2103Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_6",
    d: "M105.67 98.1726L105.048 91.7875H106.273L105.67 98.1726Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_6",
    d: "M113.5 90.2126L107.114 90.8349L107.114 89.6096L113.5 90.2126Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_6",
    d: "M97.6975 90.2126L104.083 90.8349L104.083 89.6096L97.6975 90.2126Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_7",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 138.537 83.9946)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_7",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 138.537 83.9947)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_7",
    d: "M138.546 75.9827L137.924 82.3678H139.149L138.546 75.9827Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_7",
    d: "M138.546 91.945L137.924 85.5599H139.149L138.546 91.945Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_7",
    d: "M146.375 83.985L139.99 84.6073L139.99 83.382L146.375 83.985Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_7",
    d: "M130.573 83.985L136.959 84.6073L136.959 83.382L130.573 83.985Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_8",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 148.408 52.5108)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_8",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 148.408 52.5109)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_8",
    d: "M148.417 44.499L147.795 50.8841H149.02L148.417 44.499Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_8",
    d: "M148.417 60.4612L147.795 54.0761H149.02L148.417 60.4612Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_8",
    d: "M156.246 52.5013L149.861 53.1236L149.861 51.8982L156.246 52.5013Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_8",
    d: "M140.444 52.5013L146.829 53.1236L146.829 51.8982L140.444 52.5013Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_9",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 120.159 57.1795)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_9",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 120.159 57.1796)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_9",
    d: "M120.169 49.1677L119.546 55.5528H120.772L120.169 49.1677Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_9",
    d: "M120.169 65.1299L119.546 58.7448H120.772L120.169 65.1299Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_9",
    d: "M127.998 57.17L121.613 57.7923L121.613 56.5669L127.998 57.17Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_9",
    d: "M112.196 57.17L118.581 57.7923L118.581 56.5669L112.196 57.17Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_10",
    r: 2.71999,
    transform: "matrix(-1 0 0 1 135.996 114.197)",
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_10",
    r: 1.75829,
    transform: "matrix(-1 0 0 1 135.996 114.198)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_10",
    d: "M136.006 106.186L135.383 112.571H136.609L136.006 106.186Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_10",
    d: "M136.006 122.148L135.383 115.763H136.609L136.006 122.148Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_10",
    d: "M143.835 114.188L137.45 114.81L137.45 113.585L143.835 114.188Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_10",
    d: "M128.033 114.188L134.418 114.81L134.418 113.585L128.033 114.188Z",
    fill: "white",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 49",
    d: "M150.851 173.061L146.045 175.828L146.173 130.628L150.173 129.218L150.851 173.061Z",
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hide1",
    d: "M323.017 217.168L249.083 174.081L168.328 217.168L249.083 260.233L323.017 217.168Z",
    fill: "#65813F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fragezeichen_Anschlussanfrage"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.118 146.532L246.095 144.016L246.096 144.11C246.065 144.069 246.035 144.028 246.005 143.988L242.808 147.973C243.972 149.23 245.015 150.582 245.913 152.001C246.887 153.53 247.714 155.116 248.381 156.731C249.065 158.352 249.539 159.998 249.791 161.623C250.02 163.084 250.007 164.506 249.753 165.832C249.533 167.019 249.02 168.062 248.253 168.885C247.805 169.385 247.215 169.742 246.528 169.929C245.907 170.082 245.226 170.097 244.523 169.974C243.805 169.843 243.082 169.643 242.365 169.377L240.28 168.588C239.365 168.21 238.432 168.009 237.539 167.998C236.705 168.029 235.941 168.253 235.305 168.655C234.342 169.292 233.472 170.039 232.705 170.886L234.779 175.887L229.566 173.57L229.622 173.89L229.477 173.539L225.629 177.535L228.626 184.814L231.247 182.091L229.863 187.703L241.5 186.071L236.443 177.521L241.366 179.578L241.359 179.553L241.368 179.576C242.498 178.394 243.45 177.736 244.222 177.604C244.994 177.472 246.316 177.775 248.188 178.511C249.611 179.047 251.047 179.449 252.473 179.71C253.52 179.905 254.531 179.866 255.433 179.597C256.319 179.274 257.085 178.764 257.691 178.094C258.986 176.674 259.845 174.881 260.205 172.848C260.667 170.492 260.706 167.965 260.32 165.367C259.941 162.627 259.17 159.844 258.03 157.104C257.251 155.204 256.346 153.325 255.323 151.482C254.38 149.788 253.313 148.139 252.133 146.55L252.138 146.541L252.121 146.534L252.119 146.531L252.118 146.532Z",
    fill: "#2B2B2B",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M216.86 108.594C219.521 109.181 222.128 109.989 224.654 111.011C227.391 112.123 230.045 113.429 232.596 114.918C236.291 117.045 239.664 119.687 242.616 122.764C245.44 125.648 247.78 128.969 249.547 132.598C251.109 135.68 251.957 139.074 252.028 142.528C252.066 144.152 251.797 145.768 251.235 147.292C250.607 148.764 249.653 150.076 248.447 151.129C246.806 152.569 245.024 153.839 243.127 154.92C240.604 156.301 239.026 157.559 238.395 158.693C237.765 159.827 237.453 161.864 237.462 164.806L229.181 160.023C229.134 157.97 229.282 155.916 229.623 153.891C229.866 152.576 230.402 151.333 231.189 150.252C232.072 149.154 233.174 148.25 234.425 147.599L237.206 146.019C238.158 145.47 239.054 144.827 239.879 144.101C240.682 143.384 241.334 142.515 241.797 141.544C242.294 140.444 242.534 139.246 242.501 138.039C242.476 136.017 241.996 134.025 241.094 132.214C240.093 130.18 238.767 128.322 237.168 126.715C235.39 124.924 233.377 123.384 231.183 122.137C229.01 120.877 226.707 119.854 224.315 119.087C222.1 118.37 219.808 117.919 217.486 117.744L216.86 108.594ZM238.306 173.176V183.151L228.523 177.46V167.485L238.306 173.176Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 352",
    d: "M208.6 112.852L216.886 108.585L219.214 116.858L212.606 118.331L208.6 112.852Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 353",
    d: "M225.681 165.563L230.728 159.939L237.46 164.811L229.2 169.066L225.681 165.563Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 354",
    d: "M220.264 171.748L229.089 167.503L232.64 170.976L228.39 179.613L220.264 171.748Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 355",
    d: "M226.364 181.823L229.203 176.086L238.315 183.134L230.047 187.412L226.364 181.823Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 53",
    d: "M243.236 127.413C240.981 121.866 225.986 116.42 218.77 114.39L218.093 120.141L228.015 124.82L240.474 142.296L244.082 141.281C244.74 138.97 245.491 132.96 243.236 127.413Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    d: "M208.484 112.928C211.145 113.515 213.753 114.323 216.279 115.345C219.016 116.457 221.67 117.762 224.221 119.252C227.916 121.379 231.289 124.02 234.24 127.097C237.065 129.982 239.405 133.302 241.172 136.932C242.734 140.014 243.582 143.408 243.653 146.862C243.691 148.486 243.422 150.102 242.86 151.626C242.231 153.098 241.278 154.41 240.072 155.462C238.431 156.903 236.649 158.173 234.752 159.254C232.228 160.635 230.651 161.893 230.02 163.027C229.389 164.161 229.078 166.198 229.087 169.14L220.806 164.357C220.759 162.303 220.906 160.25 221.247 158.225C221.491 156.91 222.027 155.667 222.814 154.586C223.697 153.487 224.799 152.584 226.049 151.933L228.831 150.353C229.783 149.804 230.678 149.161 231.504 148.435C232.307 147.718 232.959 146.849 233.422 145.877C233.918 144.778 234.159 143.579 234.125 142.373C234.101 140.35 233.62 138.359 232.719 136.548C231.718 134.514 230.392 132.656 228.793 131.049C227.015 129.258 225.002 127.717 222.807 126.471C220.634 125.211 218.332 124.188 215.94 123.421C213.725 122.703 211.433 122.253 209.111 122.078L208.484 112.928ZM229.931 177.51V187.485L220.147 181.794V171.819L229.931 177.51Z",
    fill: "#C3337F"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "dot-anschlussanfrage-vorne",
    cx: 148.291,
    cy: 137.312,
    r: 6.31184,
    fill: "#B4005F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1137_494",
    x1: 327.771,
    y1: 190.794,
    x2: 413.978,
    y2: 134.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118587
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnschlussanfrage);
export default __webpack_public_path__ + "static/media/Anschlussanfrage.b30ddaa8feaff23675daee1408aa8a2a.svg";
export { ForwardRef as ReactComponent };